import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** The `Upload` scalar type represents a file upload. */
  Upload: any,
};


export enum Account {
  Cash = 'CASH',
  Land = 'LAND',
  Building = 'BUILDING',
  Equipment = 'EQUIPMENT',
  Furnishing = 'FURNISHING',
  Stock = 'STOCK',
  LoanPayable = 'LOAN_PAYABLE',
  AvertisingExpense = 'AVERTISING_EXPENSE',
  Cogs = 'COGS',
  SalesReturnsAndAllowances = 'SALES_RETURNS_AND_ALLOWANCES',
  Inventory = 'INVENTORY',
  Revenue = 'REVENUE',
  AdvertisingExpense = 'ADVERTISING_EXPENSE',
  DepreciationExpense = 'DEPRECIATION_EXPENSE',
  ADLand = 'A_D_LAND',
  ADBuilding = 'A_D_BUILDING',
  ADEquipment = 'A_D_EQUIPMENT',
  ADFurnishing = 'A_D_FURNISHING',
  InterestExpense = 'INTEREST_EXPENSE',
  IncomeTaxExpense = 'INCOME_TAX_EXPENSE',
  IncomeSummary = 'INCOME_SUMMARY',
  RetainedEarnings = 'RETAINED_EARNINGS',
  GainOnSale = 'GAIN_ON_SALE',
  BondsPayable = 'BONDS_PAYABLE',
  PremiumOnBonds = 'PREMIUM_ON_BONDS',
  DiscountOnBonds = 'DISCOUNT_ON_BONDS',
  Receivable = 'RECEIVABLE',
  BadDebt = 'BAD_DEBT'
}

export type AdvertisingFeature = {
   __typename?: 'AdvertisingFeature',
  cost: Scalars['Float'],
  benefit: Scalars['Float'],
};

export type AdvertisingFeatureInput = {
  cost: Scalars['Float'],
  benefit: Scalars['Float'],
};

export type ArRoundFeature = {
   __typename?: 'ARRoundFeature',
  outstandingPercent: Scalars['Float'],
  badDebtPercent: Scalars['Float'],
};

export type ArRoundFeatureInput = {
  outstandingPercent: Scalars['Float'],
  badDebtPercent: Scalars['Float'],
};

export enum AssetType {
  Land = 'LAND',
  Building = 'BUILDING',
  Equipment = 'EQUIPMENT',
  Furnishing = 'FURNISHING',
  Debt = 'DEBT',
  Bond = 'BOND'
}

export type BalanceSheet = {
   __typename?: 'BalanceSheet',
  id: Scalars['ID'],
  team?: Maybe<Team>,
  roundConfigId: Scalars['ID'],
  cash?: Maybe<Scalars['Float']>,
  inventory?: Maybe<Scalars['Float']>,
  equipment?: Maybe<Scalars['Float']>,
  equipmentDepreciation?: Maybe<Scalars['Float']>,
  buildings?: Maybe<Scalars['Float']>,
  buildingsDepreciation?: Maybe<Scalars['Float']>,
  furnishings?: Maybe<Scalars['Float']>,
  furnishingsDepreciation?: Maybe<Scalars['Float']>,
  land?: Maybe<Scalars['Float']>,
  totalAssets?: Maybe<Scalars['Float']>,
  loanPayable?: Maybe<Scalars['Float']>,
  totalLiabilities?: Maybe<Scalars['Float']>,
  commonStock?: Maybe<Scalars['Float']>,
  retainedEarnings?: Maybe<Scalars['Float']>,
  totalLiabilitiesAndEquity?: Maybe<Scalars['Float']>,
  bondsPayable?: Maybe<Scalars['Float']>,
  bondsPremiumOrDiscount?: Maybe<Scalars['Float']>,
  submittedBy?: Maybe<User>,
  incorrectAnswers?: Maybe<Array<Maybe<FieldAnswer>>>,
  disabledFieldAnswers?: Maybe<Array<Maybe<FieldAnswer>>>,
  createdAt?: Maybe<Scalars['String']>,
};

export type BalanceSheetConfig = {
   __typename?: 'BalanceSheetConfig',
  roundSetting: RoundModuleDisplaySettingEnum,
  disabledFields?: Maybe<Array<Maybe<BalanceSheetDisabledFieldsEnum>>>,
};

export type BalanceSheetConfigInput = {
  roundSetting: RoundModuleDisplaySettingEnum,
  disabledFields?: Maybe<Array<Maybe<BalanceSheetDisabledFieldsEnum>>>,
};

/** Enum values match field names for ease of use converting between ENUM and form field on the client */
export enum BalanceSheetDisabledFieldsEnum {
  Cash = 'cash',
  Inventory = 'inventory',
  Equipment = 'equipment',
  EquipmentDepreciation = 'equipmentDepreciation',
  Buildings = 'buildings',
  BuildingsDepreciation = 'buildingsDepreciation',
  Furnishings = 'furnishings',
  FurnishingsDepreciation = 'furnishingsDepreciation',
  Land = 'land',
  TotalAssets = 'totalAssets',
  LoanPayable = 'loanPayable',
  TotalLiabilities = 'totalLiabilities',
  CommonStock = 'commonStock',
  RetainedEarnings = 'retainedEarnings',
  TotalLiabilitiesAndEquity = 'totalLiabilitiesAndEquity',
  BondsPayable = 'bondsPayable',
  BondsPremiumOrDiscount = 'bondsPremiumOrDiscount'
}

export type BalanceSheetInput = {
  teamId?: Maybe<Scalars['ID']>,
  roundConfigId?: Maybe<Scalars['ID']>,
  cash?: Maybe<Scalars['Float']>,
  inventory?: Maybe<Scalars['Float']>,
  equipment?: Maybe<Scalars['Float']>,
  equipmentDepreciation?: Maybe<Scalars['Float']>,
  buildings?: Maybe<Scalars['Float']>,
  buildingsDepreciation?: Maybe<Scalars['Float']>,
  furnishings?: Maybe<Scalars['Float']>,
  furnishingsDepreciation?: Maybe<Scalars['Float']>,
  land?: Maybe<Scalars['Float']>,
  totalAssets?: Maybe<Scalars['Float']>,
  loanPayable?: Maybe<Scalars['Float']>,
  totalLiabilities?: Maybe<Scalars['Float']>,
  commonStock?: Maybe<Scalars['Float']>,
  retainedEarnings?: Maybe<Scalars['Float']>,
  totalLiabilitiesAndEquity?: Maybe<Scalars['Float']>,
  bondsPayable?: Maybe<Scalars['Float']>,
  bondsPremiumOrDiscount?: Maybe<Scalars['Float']>,
};

export type BondAsset = {
   __typename?: 'BondAsset',
  id?: Maybe<Scalars['ID']>,
  team?: Maybe<Team>,
  nominalAmount?: Maybe<Scalars['Float']>,
  friendlyId?: Maybe<Scalars['String']>,
  quantityIssued?: Maybe<Scalars['Int']>,
  roundIssued?: Maybe<Scalars['Int']>,
  yearsRemaining?: Maybe<Scalars['Int']>,
  nominalInterestRate?: Maybe<Scalars['Float']>,
  marketRate?: Maybe<Scalars['Float']>,
  unamortizedPremiumOrDiscount?: Maybe<Scalars['Float']>,
};

export type BondLiability = {
   __typename?: 'BondLiability',
  id: Scalars['ID'],
  team: Team,
  name: Scalars['String'],
  principal: Scalars['Float'],
  term: Scalars['Int'],
  roundBorrowedIndex: Scalars['Int'],
  realRate: Scalars['Float'],
  nominalRate: Scalars['Float'],
  bondElectionId: Scalars['ID'],
  bondConfigId: Scalars['ID'],
  pvInterest: Scalars['Float'],
  pvPrincipal: Scalars['Float'],
  originalPremiumOrDiscount: Scalars['Float'],
  unamortizedPremiumOrDiscount: Scalars['Float'],
  cumulativeAmortizationChanges: Scalars['Float'],
  maturationRoundId?: Maybe<Scalars['ID']>,
  quantityIssued: Scalars['Int'],
  friendlyId: Scalars['String'],
};

export type BondOptions = {
   __typename?: 'BondOptions',
  id?: Maybe<Scalars['ID']>,
  miniId?: Maybe<Scalars['String']>,
  nominalAmount: Scalars['Float'],
  nominalInterestRate: Scalars['Float'],
  paymentDueQuarterEnd: Scalars['Int'],
  numPaymentsPerYear: Scalars['Int'],
  term: Scalars['Int'],
};

export type BondOptionsInput = {
  nominalAmount: Scalars['Float'],
  nominalInterestRate: Scalars['Float'],
  paymentDueQuarterEnd: Scalars['Int'],
  numPaymentsPerYear: Scalars['Int'],
  term: Scalars['Int'],
};

export type BondSaleElection = {
   __typename?: 'BondSaleElection',
  bondConfigId: Scalars['ID'],
  numBondsSold: Scalars['Int'],
  nominalAmount: Scalars['Float'],
};

export type BondSaleElectionInput = {
  bondConfigId: Scalars['ID'],
  numBondsSold: Scalars['Int'],
  nominalAmount: Scalars['Float'],
};

export type BondsConfig = {
   __typename?: 'BondsConfig',
  realInterestRateFactor: Scalars['Float'],
  bondOptions?: Maybe<Array<Maybe<BondOptions>>>,
};

export type BondsConfigInput = {
  realInterestRateFactor: Scalars['Float'],
  bondOptions?: Maybe<Array<Maybe<BondOptionsInput>>>,
};

export type BorrowingCapsFeature = {
   __typename?: 'BorrowingCapsFeature',
  debtRoundBorrowCap: Scalars['Float'],
  bondRoundBorrowCap: Scalars['Float'],
  totalPrincipalCap: Scalars['Float'],
};

export type BorrowingCapsFeatureInput = {
  debtRoundBorrowCap: Scalars['Float'],
  bondRoundBorrowCap: Scalars['Float'],
  totalPrincipalCap: Scalars['Float'],
};

export type BuildingAsset = {
   __typename?: 'BuildingAsset',
  id?: Maybe<Scalars['ID']>,
  team?: Maybe<Team>,
  name?: Maybe<Scalars['String']>,
  buildingConfigId?: Maybe<Scalars['ID']>,
  purchaseElectionId?: Maybe<Scalars['ID']>,
  saleElectionId?: Maybe<Scalars['ID']>,
  totalCapacity?: Maybe<Scalars['Int']>,
  usefulLife?: Maybe<Scalars['Int']>,
  remainingUsefulLife?: Maybe<Scalars['Int']>,
  roundPurchasedIndex?: Maybe<Scalars['Int']>,
  originalPurchasePrice?: Maybe<Scalars['Float']>,
  salePrice?: Maybe<Scalars['Float']>,
  equipments?: Maybe<Array<Maybe<EquipmentAsset>>>,
  isSellable?: Maybe<Scalars['Boolean']>,
  isSold?: Maybe<Scalars['Boolean']>,
  depreciationMethod?: Maybe<Scalars['String']>,
  annualDepreciationPercent?: Maybe<Scalars['Float']>,
  depreciationExpense?: Maybe<Scalars['Float']>,
  a_d?: Maybe<Scalars['Float']>,
  expiringRoundId?: Maybe<Scalars['ID']>,
  friendlyId: Scalars['String'],
  originalRoundPurchasedNum?: Maybe<Scalars['Int']>,
};

export type BuildingAssetInput = {
  name: Scalars['String'],
  land: Scalars['String'],
  totalCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  depreciationMethod?: Maybe<Scalars['String']>,
};

export type BuildingConfig = {
   __typename?: 'BuildingConfig',
  id?: Maybe<Scalars['ID']>,
  typesConfig?: Maybe<Array<Maybe<BuildingTypeDynamicConfig>>>,
};

export type BuildingConfigInput = {
  id?: Maybe<Scalars['ID']>,
  typesConfig: Array<Maybe<BuildingTypeDynamicConfigInput>>,
};

export type BuildingPurchaseElection = {
   __typename?: 'BuildingPurchaseElection',
  buildingConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  type: Scalars['String'],
  depreciationMethod: Scalars['String'],
  capacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
};

export type BuildingPurchaseElectionInput = {
  buildingConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  type: Scalars['String'],
  depreciationMethod: Scalars['String'],
  capacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
};

export type BuildingSaleElection = {
   __typename?: 'BuildingSaleElection',
  buildingAssetId?: Maybe<Scalars['ID']>,
  buildingConfigId?: Maybe<Scalars['ID']>,
  salePrice?: Maybe<Scalars['Float']>,
  originalPurchasePrice?: Maybe<Scalars['Float']>,
};

export type BuildingSaleElectionInput = {
  buildingAssetId?: Maybe<Scalars['ID']>,
  buildingConfigId?: Maybe<Scalars['ID']>,
  salePrice: Scalars['Float'],
  originalPurchasePrice: Scalars['Float'],
};

export type BuildingTypeDynamicConfig = {
   __typename?: 'BuildingTypeDynamicConfig',
  miniId: Scalars['String'],
  buildingType: Scalars['String'],
  purchaseCost: Scalars['Float'],
  equipmentCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  depreciationMethods: Array<Maybe<Scalars['String']>>,
  defaultDepreciationMethod: Scalars['String'],
};

export type BuildingTypeDynamicConfigInput = {
  buildingType: Scalars['String'],
  purchaseCost: Scalars['Float'],
  equipmentCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  depreciationMethods: Array<Maybe<Scalars['String']>>,
  defaultDepreciationMethod: Scalars['String'],
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CashFlow = {
   __typename?: 'CashFlow',
  id: Scalars['ID'],
  team: Team,
  roundConfigId: Scalars['ID'],
  operatingActivitiesSales?: Maybe<Scalars['Float']>,
  operatingActivitiesPurchasedInventory?: Maybe<Scalars['Float']>,
  operatingActivitiesPaidAdvertising?: Maybe<Scalars['Float']>,
  operatingActivitiesSalesReturns?: Maybe<Scalars['Float']>,
  operatingActivitiesIncomeTaxesPaid?: Maybe<Scalars['Float']>,
  operatingActivitiesInterestPaid?: Maybe<Scalars['Float']>,
  operatingActivitiesTotal?: Maybe<Scalars['Float']>,
  investingActivitiesInflowEquipment?: Maybe<Scalars['Float']>,
  investingActivitiesInflowBuildings?: Maybe<Scalars['Float']>,
  investingActivitiesInflowLand?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowEquipment?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowBuildings?: Maybe<Scalars['Float']>,
  investingActivitiesInflowFurnishings?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowFurnishings?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowLand?: Maybe<Scalars['Float']>,
  investingActivitiesTotal?: Maybe<Scalars['Float']>,
  financingActivitiesCapital?: Maybe<Scalars['Float']>,
  bondBorrowing?: Maybe<Scalars['Float']>,
  financingActivitiesLoanBorrow?: Maybe<Scalars['Float']>,
  bondRepayment?: Maybe<Scalars['Float']>,
  financingActivitiesLoanRepay?: Maybe<Scalars['Float']>,
  financingActivitiesTotal?: Maybe<Scalars['Float']>,
  netCash?: Maybe<Scalars['Float']>,
  beginningOfRound?: Maybe<Scalars['Float']>,
  endOfRound?: Maybe<Scalars['Float']>,
  submittedBy?: Maybe<User>,
  incorrectAnswers?: Maybe<Array<Maybe<FieldAnswer>>>,
  disabledFieldAnswers?: Maybe<Array<Maybe<FieldAnswer>>>,
  createdAt?: Maybe<Scalars['String']>,
};

export type CashFlowConfig = {
   __typename?: 'CashFlowConfig',
  roundSetting: RoundModuleDisplaySettingEnum,
  disabledFields?: Maybe<Array<Maybe<CashFlowDisabledFieldsEnum>>>,
};

export type CashFlowConfigInput = {
  roundSetting: RoundModuleDisplaySettingEnum,
  disabledFields?: Maybe<Array<Maybe<CashFlowDisabledFieldsEnum>>>,
};

export enum CashFlowDisabledFieldsEnum {
  OperatingActivitiesSales = 'operatingActivitiesSales',
  OperatingActivitiesPurchasedInventory = 'operatingActivitiesPurchasedInventory',
  OperatingActivitiesPaidAdvertising = 'operatingActivitiesPaidAdvertising',
  OperatingActivitiesSalesReturns = 'operatingActivitiesSalesReturns',
  OperatingActivitiesIncomeTaxesPaid = 'operatingActivitiesIncomeTaxesPaid',
  OperatingActivitiesInterestPaid = 'operatingActivitiesInterestPaid',
  OperatingActivitiesTotal = 'operatingActivitiesTotal',
  InvestingActivitiesInflowEquipment = 'investingActivitiesInflowEquipment',
  InvestingActivitiesInflowBuildings = 'investingActivitiesInflowBuildings',
  InvestingActivitiesInflowLand = 'investingActivitiesInflowLand',
  InvestingActivitiesOutflowEquipment = 'investingActivitiesOutflowEquipment',
  InvestingActivitiesOutflowBuildings = 'investingActivitiesOutflowBuildings',
  InvestingActivitiesInflowFurnishings = 'investingActivitiesInflowFurnishings',
  InvestingActivitiesOutflowFurnishings = 'investingActivitiesOutflowFurnishings',
  InvestingActivitiesOutflowLand = 'investingActivitiesOutflowLand',
  InvestingActivitiesTotal = 'investingActivitiesTotal',
  FinancingActivitiesCapital = 'financingActivitiesCapital',
  FinancingActivitiesLoanBorrow = 'financingActivitiesLoanBorrow',
  FinancingActivitiesLoanRepay = 'financingActivitiesLoanRepay',
  FinancingActivitiesTotal = 'financingActivitiesTotal',
  NetCash = 'netCash',
  BeginningOfRound = 'beginningOfRound',
  EndOfRound = 'endOfRound',
  BondBorrowing = 'bondBorrowing',
  BondRepayment = 'bondRepayment'
}

export type CashFlowInput = {
  teamId?: Maybe<Scalars['ID']>,
  roundConfigId?: Maybe<Scalars['ID']>,
  operatingActivitiesSales?: Maybe<Scalars['Float']>,
  operatingActivitiesPurchasedInventory?: Maybe<Scalars['Float']>,
  operatingActivitiesPaidAdvertising?: Maybe<Scalars['Float']>,
  operatingActivitiesSalesReturns?: Maybe<Scalars['Float']>,
  operatingActivitiesIncomeTaxesPaid?: Maybe<Scalars['Float']>,
  operatingActivitiesInterestPaid?: Maybe<Scalars['Float']>,
  operatingActivitiesTotal?: Maybe<Scalars['Float']>,
  investingActivitiesInflowEquipment?: Maybe<Scalars['Float']>,
  investingActivitiesInflowBuildings?: Maybe<Scalars['Float']>,
  investingActivitiesInflowLand?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowEquipment?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowBuildings?: Maybe<Scalars['Float']>,
  investingActivitiesInflowFurnishings?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowFurnishings?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowLand?: Maybe<Scalars['Float']>,
  investingActivitiesTotal?: Maybe<Scalars['Float']>,
  financingActivitiesCapital?: Maybe<Scalars['Float']>,
  bondBorrowing?: Maybe<Scalars['Float']>,
  financingActivitiesLoanBorrow?: Maybe<Scalars['Float']>,
  bondRepayment?: Maybe<Scalars['Float']>,
  financingActivitiesLoanRepay?: Maybe<Scalars['Float']>,
  financingActivitiesTotal?: Maybe<Scalars['Float']>,
  netCash?: Maybe<Scalars['Float']>,
  beginningOfRound?: Maybe<Scalars['Float']>,
  endOfRound?: Maybe<Scalars['Float']>,
};

export type CheckGameFlowsResult = {
   __typename?: 'CheckGameFlowsResult',
  marketCalcedSemesters: Array<Maybe<GameRoundTuple>>,
  gradedSemesters: Array<Maybe<GameRoundTuple>>,
};

export type Course = {
   __typename?: 'Course',
  id: Scalars['ID'],
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  minTeams: Scalars['Int'],
  maxTeams: Scalars['Int'],
  minStudentsPerTeam: Scalars['Int'],
  maxStudentsPerTeam: Scalars['Int'],
  createdBy?: Maybe<User>,
  gameProducts?: Maybe<Array<Maybe<GameProduct>>>,
  rounds?: Maybe<Array<Maybe<RoundConfig>>>,
  defaultGameConfig: GameConfig,
};

export type CourseInput = {
  name: Scalars['String'],
  description: Scalars['String'],
  minTeams: Scalars['Int'],
  maxTeams: Scalars['Int'],
  minStudentsPerTeam: Scalars['Int'],
  maxStudentsPerTeam: Scalars['Int'],
  gameProducts?: Maybe<Array<Maybe<Scalars['String']>>>,
  rounds: Array<Maybe<RoundConfigInput>>,
  defaultGameConfig?: Maybe<GameConfigInput>,
};

export type CourseTemplate = {
   __typename?: 'CourseTemplate',
  id: Scalars['ID'],
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  minTeams: Scalars['Int'],
  maxTeams: Scalars['Int'],
  minStudentsPerTeam: Scalars['Int'],
  maxStudentsPerTeam: Scalars['Int'],
  gameProducts?: Maybe<Array<Maybe<Scalars['String']>>>,
  rounds?: Maybe<Array<Maybe<RoundConfig>>>,
  defaultGameConfig: GameConfig,
  isLive: Scalars['Boolean'],
  professor?: Maybe<User>,
  isSystemTemplate: Scalars['Boolean'],
};

export type CourseTemplateGameConfigInput = {
  preloadAssets: PreloadAssetsInput,
  roundFeatures: GameConfigRoundFeaturesInput,
  junkLoans: JunkLoanConfigInput,
  stockConfig: StockConfigInput,
};

export type CourseTemplateInput = {
  minTeams: Scalars['Int'],
  maxTeams: Scalars['Int'],
  minStudentsPerTeam: Scalars['Int'],
  maxStudentsPerTeam: Scalars['Int'],
  gameProducts?: Maybe<Array<Maybe<Scalars['String']>>>,
  rounds: Array<Maybe<RoundConfigInput>>,
  defaultGameConfig?: Maybe<CourseTemplateGameConfigInput>,
};

export type CurrentAssets = {
   __typename?: 'CurrentAssets',
  currentCashBalance?: Maybe<Scalars['Float']>,
  lands?: Maybe<Array<Maybe<LandAsset>>>,
  buildings?: Maybe<Array<Maybe<BuildingAsset>>>,
  equipments?: Maybe<Array<Maybe<EquipmentAsset>>>,
  storeFurnishings?: Maybe<Array<Maybe<StoreFurnishingAsset>>>,
  debts?: Maybe<Array<Maybe<DebtLiability>>>,
  products?: Maybe<Array<Maybe<ProductInventoryReport>>>,
  stocks?: Maybe<Array<Maybe<StockSaleElection>>>,
  bonds?: Maybe<Array<Maybe<BondAsset>>>,
};

export type CustomLabel = {
   __typename?: 'CustomLabel',
  key: Scalars['String'],
  value: Scalars['String'],
  group?: Maybe<CustomLabelGroup>,
};

export enum CustomLabelGroup {
  Advertising = 'ADVERTISING'
}

export type DebtBorrowElection = {
   __typename?: 'DebtBorrowElection',
  debtConfigId: Scalars['ID'],
  rate: Scalars['Float'],
  term: Scalars['Int'],
  borrowingAmount: Scalars['Float'],
  friendlyId: Scalars['String'],
};

export type DebtBorrowElectionInput = {
  debtConfigId: Scalars['ID'],
  rate: Scalars['Float'],
  term: Scalars['Int'],
  borrowingAmount: Scalars['Float'],
  friendlyId: Scalars['String'],
};

export type DebtConfig = {
   __typename?: 'DebtConfig',
  id?: Maybe<Scalars['ID']>,
  borrowingRate: Scalars['Float'],
  borrowingTerm: Scalars['Int'],
  repaymentRoundId?: Maybe<Scalars['ID']>,
  miniId: Scalars['String'],
};

export type DebtConfigInput = {
  id?: Maybe<Scalars['ID']>,
  borrowingRate: Scalars['Float'],
  borrowingTerm: Scalars['Int'],
};

export type DebtLiability = {
   __typename?: 'DebtLiability',
  id: Scalars['ID'],
  team?: Maybe<Team>,
  name?: Maybe<Scalars['String']>,
  debtConfigId?: Maybe<Scalars['ID']>,
  borrowElectionId?: Maybe<Scalars['ID']>,
  originalRate?: Maybe<Scalars['Float']>,
  originalTerm?: Maybe<Scalars['Int']>,
  yearsIntoTerm?: Maybe<Scalars['Int']>,
  originalPrincipal?: Maybe<Scalars['Float']>,
  outstandingPrincipal?: Maybe<Scalars['Float']>,
  roundBorrowedIndex?: Maybe<Scalars['Int']>,
  repayments?: Maybe<Array<Maybe<DebtRepayment>>>,
  isSellable?: Maybe<Scalars['Boolean']>,
  isPaidOff?: Maybe<Scalars['Boolean']>,
  repaymentRoundId?: Maybe<Scalars['ID']>,
  friendlyId: Scalars['String'],
  originalRoundBorrowedNum?: Maybe<Scalars['Int']>,
};

export type DebtLiabilityInput = {
  name: Scalars['String'],
  originalRate: Scalars['Float'],
  originalTerm: Scalars['Int'],
  originalPrincipal: Scalars['Float'],
};

export type DebtRepayment = {
   __typename?: 'DebtRepayment',
  debtLiabilityId?: Maybe<Scalars['ID']>,
  repaymentRoundId: Scalars['ID'],
  repaymentAmount: Scalars['Float'],
  timeStamp: Scalars['Float'],
};

export type DebtRepaymentElection = {
   __typename?: 'DebtRepaymentElection',
  debtLiabilityId?: Maybe<Scalars['ID']>,
  debtConfigId?: Maybe<Scalars['ID']>,
  rate: Scalars['Float'],
  term: Scalars['Int'],
  originalPrincipal: Scalars['Float'],
  repaymentAmount: Scalars['Float'],
};

export type DebtRepaymentElectionInput = {
  debtLiabilityId?: Maybe<Scalars['ID']>,
  debtConfigId?: Maybe<Scalars['ID']>,
  rate: Scalars['Float'],
  term: Scalars['Int'],
  originalPrincipal: Scalars['Float'],
  repaymentAmount: Scalars['Float'],
};

export enum EmailPreference {
  All = 'ALL',
  Critical = 'CRITICAL',
  None = 'NONE'
}

export type EquipmentAsset = {
   __typename?: 'EquipmentAsset',
  id?: Maybe<Scalars['ID']>,
  team?: Maybe<Team>,
  name?: Maybe<Scalars['String']>,
  equipmentConfigId?: Maybe<Scalars['ID']>,
  purchaseElectionId?: Maybe<Scalars['ID']>,
  saleElectionId?: Maybe<Scalars['ID']>,
  totalCapacity?: Maybe<Scalars['Int']>,
  usefulLife?: Maybe<Scalars['Int']>,
  remainingUsefulLife?: Maybe<Scalars['Int']>,
  roundPurchasedIndex?: Maybe<Scalars['Int']>,
  originalPurchasePrice?: Maybe<Scalars['Float']>,
  salePrice?: Maybe<Scalars['Float']>,
  isSellable?: Maybe<Scalars['Boolean']>,
  isSold?: Maybe<Scalars['Boolean']>,
  depreciationMethod?: Maybe<Scalars['String']>,
  annualDepreciationPercent?: Maybe<Scalars['Float']>,
  depreciationExpense?: Maybe<Scalars['Float']>,
  a_d?: Maybe<Scalars['Float']>,
  expiringRoundId?: Maybe<Scalars['ID']>,
  friendlyId: Scalars['String'],
  originalRoundPurchasedNum?: Maybe<Scalars['Int']>,
};

export type EquipmentAssetInput = {
  name: Scalars['String'],
  building: Scalars['String'],
  totalCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  depreciationMethod?: Maybe<Scalars['String']>,
};

export type EquipmentConfig = {
   __typename?: 'EquipmentConfig',
  id?: Maybe<Scalars['ID']>,
  typesConfig?: Maybe<Array<Maybe<EquipmentTypeDynamicConfig>>>,
};

export type EquipmentConfigInput = {
  id?: Maybe<Scalars['ID']>,
  typesConfig: Array<Maybe<EquipmentTypeDynamicConfigInput>>,
};

export type EquipmentPurchaseElection = {
   __typename?: 'EquipmentPurchaseElection',
  equipmentConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  type: Scalars['String'],
  depreciationMethod: Scalars['String'],
  capacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
};

export type EquipmentPurchaseElectionInput = {
  equipmentConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  type: Scalars['String'],
  depreciationMethod: Scalars['String'],
  capacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
};

export type EquipmentSaleElection = {
   __typename?: 'EquipmentSaleElection',
  equipmentAssetId?: Maybe<Scalars['ID']>,
  equipmentConfigId?: Maybe<Scalars['ID']>,
  salePrice?: Maybe<Scalars['Float']>,
  originalPurchasePrice?: Maybe<Scalars['Float']>,
};

export type EquipmentSaleElectionInput = {
  equipmentAssetId?: Maybe<Scalars['ID']>,
  equipmentConfigId?: Maybe<Scalars['ID']>,
  salePrice: Scalars['Float'],
  originalPurchasePrice: Scalars['Float'],
};

export type EquipmentTypeDynamicConfig = {
   __typename?: 'EquipmentTypeDynamicConfig',
  miniId: Scalars['String'],
  equipmentType: Scalars['String'],
  purchaseCost: Scalars['Float'],
  productionCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  depreciationMethods: Array<Maybe<Scalars['String']>>,
  defaultDepreciationMethod: Scalars['String'],
};

export type EquipmentTypeDynamicConfigInput = {
  equipmentType: Scalars['String'],
  purchaseCost: Scalars['Float'],
  productionCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  depreciationMethods: Array<Maybe<Scalars['String']>>,
  defaultDepreciationMethod: Scalars['String'],
};

export type Error = {
   __typename?: 'Error',
  error: Scalars['String'],
};

export type FieldAnswer = {
   __typename?: 'FieldAnswer',
  fieldName?: Maybe<Scalars['String']>,
  correctAnswer?: Maybe<Scalars['Float']>,
};

export type FinancialRatio = {
   __typename?: 'FinancialRatio',
  team: Team,
  earningsPerShare?: Maybe<Scalars['Float']>,
  priceEarnings?: Maybe<Scalars['Float']>,
  debtToEquity?: Maybe<Scalars['Float']>,
  returnOnEquity?: Maybe<Scalars['Float']>,
  returnOnAssets?: Maybe<Scalars['Float']>,
};

export type GameConfig = {
   __typename?: 'GameConfig',
  preloadAssets: PreloadAssets,
  roundFeatures: GameConfigRoundFeatures,
  junkLoans: JunkLoanConfig,
  stockConfig: StockConfig,
};

export type GameConfigInput = {
  preloadAssets: PreloadAssetsInput,
  roundFeatures: GameConfigRoundFeaturesInput,
  junkLoans: JunkLoanConfigInput,
  stockConfig: StockConfigInput,
};

export type GameConfigRoundFeatures = {
   __typename?: 'GameConfigRoundFeatures',
  advertising: Array<Maybe<AdvertisingFeature>>,
  salesReturns: Array<Maybe<Scalars['Boolean']>>,
  incomeTax: Array<Maybe<Scalars['Float']>>,
  borrowingCaps: Array<Maybe<BorrowingCapsFeature>>,
  cashFlowConfig: Array<Maybe<CashFlowConfig>>,
  incomeStatementConfig: Array<Maybe<IncomeStatementConfig>>,
  balanceSheetConfig: Array<Maybe<BalanceSheetConfig>>,
  journalEntryTAccountConfig: Array<Maybe<RoundModuleDisplaySettingEnum>>,
  requirePositiveCashBalanceBeforeElecting: Array<Maybe<Scalars['Boolean']>>,
  stockPriceConfig: Array<Maybe<StockPriceFormulaConfig>>,
  accountsReceivable: Array<Maybe<ArRoundFeature>>,
};

export type GameConfigRoundFeaturesInput = {
  advertising: Array<Maybe<AdvertisingFeatureInput>>,
  salesReturns: Array<Maybe<Scalars['Boolean']>>,
  incomeTax: Array<Maybe<Scalars['Float']>>,
  borrowingCaps: Array<Maybe<BorrowingCapsFeatureInput>>,
  cashFlowConfig: Array<Maybe<CashFlowConfigInput>>,
  incomeStatementConfig: Array<Maybe<IncomeStatementConfigInput>>,
  balanceSheetConfig: Array<Maybe<BalanceSheetConfigInput>>,
  journalEntryTAccountConfig: Array<Maybe<RoundModuleDisplaySettingEnum>>,
  requirePositiveCashBalanceBeforeElecting: Array<Maybe<Scalars['Boolean']>>,
  stockPriceConfig: Array<Maybe<StockPriceFormulaConfigInput>>,
  accountsReceivable: Array<Maybe<ArRoundFeatureInput>>,
};

export type GameProduct = {
   __typename?: 'GameProduct',
  id: Scalars['ID'],
  courseId: Scalars['ID'],
  name: Scalars['String'],
};

export type GameProductInput = {
  name: Scalars['String'],
};

export type GameResults = {
   __typename?: 'GameResults',
  generalLedger: Array<ResultingGl>,
  incomeStatements: Array<ResultingIs>,
  balanceSheets: Array<ResultingBs>,
  cashFlows: Array<ResultingCf>,
  landAssets: Array<ResultingLand>,
  buildingAssets: Array<ResultingBuilding>,
  equipmentAssets: Array<ResultingEquipment>,
  loans: Array<ResultingDebt>,
  inventory: Array<ResultingInventory>,
  salesReports: Array<ResultingSalesReport>,
};

export enum GameRoundPhase {
  HasntStarted = 'HASNT_STARTED',
  InputSheet = 'INPUT_SHEET',
  CalcWaiting = 'CALC_WAITING',
  CalcSheets = 'CALC_SHEETS',
  GradeWaiting = 'GRADE_WAITING',
  Graded = 'GRADED',
  GameOver = 'GAME_OVER'
}

export type GameRoundTuple = {
   __typename?: 'GameRoundTuple',
  semesterId: Scalars['ID'],
  roundConfigId: Scalars['ID'],
};

export type GameState = {
   __typename?: 'GameState',
  roundIndex: Scalars['Int'],
  roundId?: Maybe<Scalars['ID']>,
  phase: GameRoundPhase,
  lastMarketCalc?: Maybe<MarketCalc>,
};

export type GeneralLedgerEntry = {
   __typename?: 'GeneralLedgerEntry',
  id?: Maybe<Scalars['ID']>,
  roundConfigId?: Maybe<Scalars['ID']>,
  roundIndex?: Maybe<Scalars['Int']>,
  team?: Maybe<Team>,
  amount?: Maybe<Scalars['Float']>,
  account?: Maybe<Account>,
  journalEntryId?: Maybe<Scalars['ID']>,
  miniId?: Maybe<Scalars['String']>,
  journalEntryTypeEnum?: Maybe<JournalEntryTypeEnum>,
  friendlyName?: Maybe<Scalars['String']>,
  normalBalance?: Maybe<NormalBalance>,
};

/** TODO remove this custom type and just add teamName as optional to GeneralLedgerEntry */
export type GeneralLedgerTableEntry = {
   __typename?: 'GeneralLedgerTableEntry',
  id?: Maybe<Scalars['ID']>,
  roundNum?: Maybe<Scalars['Int']>,
  teamName?: Maybe<Scalars['String']>,
  amount?: Maybe<Scalars['Float']>,
  account?: Maybe<Account>,
};

export type GradingReport = {
   __typename?: 'GradingReport',
  roundConfigId?: Maybe<Scalars['ID']>,
  teamId?: Maybe<Scalars['ID']>,
  incomeStatementNumCorrect?: Maybe<Scalars['Int']>,
  incomeStatementTotal?: Maybe<Scalars['Int']>,
  balanceSheetNumCorrect?: Maybe<Scalars['Int']>,
  balanceSheetTotal?: Maybe<Scalars['Int']>,
  cashFlowNumCorrect?: Maybe<Scalars['Int']>,
  cashFlowTotal?: Maybe<Scalars['Int']>,
  combinedNumCorrect?: Maybe<Scalars['Int']>,
  combinedTotal?: Maybe<Scalars['Int']>,
};

export type IncomeStatement = {
   __typename?: 'IncomeStatement',
  id: Scalars['ID'],
  team: Team,
  roundConfigId: Scalars['ID'],
  revenue?: Maybe<Scalars['Float']>,
  returns?: Maybe<Scalars['Float']>,
  net?: Maybe<Scalars['Float']>,
  costOfGoodsSold?: Maybe<Scalars['Float']>,
  grossProfit?: Maybe<Scalars['Float']>,
  adExpense?: Maybe<Scalars['Float']>,
  depreciationExpense?: Maybe<Scalars['Float']>,
  interest?: Maybe<Scalars['Float']>,
  gainOnAssetSales?: Maybe<Scalars['Float']>,
  accountsReceivable?: Maybe<Scalars['Float']>,
  badDebtExpense?: Maybe<Scalars['Float']>,
  total?: Maybe<Scalars['Float']>,
  incomeTax?: Maybe<Scalars['Float']>,
  netIncome?: Maybe<Scalars['Float']>,
  submittedBy?: Maybe<User>,
  incorrectAnswers?: Maybe<Array<Maybe<FieldAnswer>>>,
  disabledFieldAnswers?: Maybe<Array<Maybe<FieldAnswer>>>,
  createdAt?: Maybe<Scalars['String']>,
};

export type IncomeStatementConfig = {
   __typename?: 'IncomeStatementConfig',
  roundSetting: RoundModuleDisplaySettingEnum,
  disabledFields?: Maybe<Array<Maybe<IncomeStatementDisabledFieldsEnum>>>,
};

export type IncomeStatementConfigInput = {
  roundSetting: RoundModuleDisplaySettingEnum,
  disabledFields?: Maybe<Array<Maybe<IncomeStatementDisabledFieldsEnum>>>,
};

export enum IncomeStatementDisabledFieldsEnum {
  Revenue = 'revenue',
  Returns = 'returns',
  Net = 'net',
  CostOfGoodsSold = 'costOfGoodsSold',
  GrossProfit = 'grossProfit',
  AdExpense = 'adExpense',
  DepreciationExpense = 'depreciationExpense',
  Interest = 'interest',
  GainOnAssetSales = 'gainOnAssetSales',
  AccountsReceivable = 'accountsReceivable',
  BadDebtExpense = 'badDebtExpense',
  Total = 'total',
  IncomeTax = 'incomeTax',
  NetIncome = 'netIncome'
}

export type IncomeStatementInput = {
  teamId?: Maybe<Scalars['ID']>,
  roundConfigId?: Maybe<Scalars['ID']>,
  revenue?: Maybe<Scalars['Float']>,
  returns?: Maybe<Scalars['Float']>,
  net?: Maybe<Scalars['Float']>,
  costOfGoodsSold?: Maybe<Scalars['Float']>,
  grossProfit?: Maybe<Scalars['Float']>,
  adExpense?: Maybe<Scalars['Float']>,
  depreciationExpense?: Maybe<Scalars['Float']>,
  interest?: Maybe<Scalars['Float']>,
  gainOnAssetSales?: Maybe<Scalars['Float']>,
  accountsReceivable?: Maybe<Scalars['Float']>,
  badDebtExpense?: Maybe<Scalars['Float']>,
  total?: Maybe<Scalars['Float']>,
  incomeTax?: Maybe<Scalars['Float']>,
  netIncome?: Maybe<Scalars['Float']>,
};

export type InventoryChange = {
   __typename?: 'InventoryChange',
  productInventoryId: Scalars['ID'],
  inventoryAmount?: Maybe<Scalars['Int']>,
};

export type JournalEntriesAndTAccountsResponse = {
   __typename?: 'JournalEntriesAndTAccountsResponse',
  journalEntries?: Maybe<Array<Maybe<JournalEntry>>>,
  tAccounts?: Maybe<Array<Maybe<TAccount>>>,
};

export type JournalEntry = {
   __typename?: 'JournalEntry',
  id: Scalars['String'],
  friendlyName?: Maybe<Scalars['String']>,
  miniId?: Maybe<Scalars['String']>,
  entries?: Maybe<Array<Maybe<GeneralLedgerEntry>>>,
};

export enum JournalEntryTypeEnum {
  Stock = 'STOCK',
  LoanBorrowing = 'LOAN_BORROWING',
  EquipmentSale = 'EQUIPMENT_SALE',
  FurnishingSale = 'FURNISHING_SALE',
  BuildingSale = 'BUILDING_SALE',
  LandSale = 'LAND_SALE',
  LandPurchase = 'LAND_PURCHASE',
  BuildingPurchase = 'BUILDING_PURCHASE',
  EquipmentPurchase = 'EQUIPMENT_PURCHASE',
  FurnishingPurchase = 'FURNISHING_PURCHASE',
  LoanRepayment = 'LOAN_REPAYMENT',
  AdvertisingExpense = 'ADVERTISING_EXPENSE',
  ProduceInventory = 'PRODUCE_INVENTORY',
  Sales = 'SALES',
  CostOfGoodsSold = 'COST_OF_GOODS_SOLD',
  SalesReturns = 'SALES_RETURNS',
  ReturnedInventory = 'RETURNED_INVENTORY',
  BuildingDepreciation = 'BUILDING_DEPRECIATION',
  BuildingFullyDepreciated = 'BUILDING_FULLY_DEPRECIATED',
  EquipmentDepreciation = 'EQUIPMENT_DEPRECIATION',
  EquipmentFullyDepreciated = 'EQUIPMENT_FULLY_DEPRECIATED',
  FurnishingDepreciation = 'FURNISHING_DEPRECIATION',
  FurnishingFullyDepreciated = 'FURNISHING_FULLY_DEPRECIATED',
  InterestExpense = 'INTEREST_EXPENSE',
  CloseRevenueAccountsToIncomeSummary = 'CLOSE_REVENUE_ACCOUNTS_TO_INCOME_SUMMARY',
  CloseExpenseAccountsToIncomeSummary = 'CLOSE_EXPENSE_ACCOUNTS_TO_INCOME_SUMMARY',
  IncomeTaxExpense = 'INCOME_TAX_EXPENSE',
  CloseIncomeTaxExpenseToIncomeSummary = 'CLOSE_INCOME_TAX_EXPENSE_TO_INCOME_SUMMARY',
  CloseIncomeSummaryToRetainedEarnings = 'CLOSE_INCOME_SUMMARY_TO_RETAINED_EARNINGS',
  JunkLoanBorrowing = 'JUNK_LOAN_BORROWING',
  BondIssuance = 'BOND_ISSUANCE',
  BondIssuanceDiscount = 'BOND_ISSUANCE_DISCOUNT',
  BondIssuancePremium = 'BOND_ISSUANCE_PREMIUM',
  BondInterestDiscount = 'BOND_INTEREST_DISCOUNT',
  BondInterestPremium = 'BOND_INTEREST_PREMIUM',
  BondRepayment = 'BOND_REPAYMENT',
  ArSales = 'AR_SALES',
  ArCollections = 'AR_COLLECTIONS',
  UncollectableAr = 'UNCOLLECTABLE_AR'
}

export type JunkLoanConfig = {
   __typename?: 'JunkLoanConfig',
  rate: Scalars['Float'],
  term: Scalars['Int'],
};

export type JunkLoanConfigInput = {
  rate: Scalars['Float'],
  term: Scalars['Int'],
};

export type LandAsset = {
   __typename?: 'LandAsset',
  id: Scalars['ID'],
  team?: Maybe<Team>,
  name?: Maybe<Scalars['String']>,
  landConfigId?: Maybe<Scalars['ID']>,
  purchaseElectionId?: Maybe<Scalars['ID']>,
  saleElectionId?: Maybe<Scalars['ID']>,
  totalCapacity?: Maybe<Scalars['Int']>,
  originalPurchasePrice?: Maybe<Scalars['Float']>,
  salePrice?: Maybe<Scalars['Float']>,
  buildings?: Maybe<Array<Maybe<BuildingAsset>>>,
  isSellable?: Maybe<Scalars['Boolean']>,
  isSold?: Maybe<Scalars['Boolean']>,
  friendlyId: Scalars['String'],
  roundPurchasedIndex?: Maybe<Scalars['Int']>,
  originalRoundPurchasedNum?: Maybe<Scalars['Int']>,
};

export type LandAssetInput = {
  name: Scalars['String'],
  totalCapacity: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
};

export type LandConfig = {
   __typename?: 'LandConfig',
  miniId?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['ID']>,
  purchaseCost?: Maybe<Scalars['Float']>,
  buildingCapacity?: Maybe<Scalars['Int']>,
};

export type LandConfigInput = {
  id?: Maybe<Scalars['ID']>,
  purchaseCost: Scalars['Float'],
  buildingCapacity: Scalars['Int'],
};

export type LandPurchaseElection = {
   __typename?: 'LandPurchaseElection',
  landConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  capacity: Scalars['Int'],
};

export type LandPurchaseElectionInput = {
  landConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  capacity: Scalars['Int'],
};

export type LandSaleElection = {
   __typename?: 'LandSaleElection',
  landAssetId?: Maybe<Scalars['ID']>,
  landConfigId?: Maybe<Scalars['ID']>,
  salePrice: Scalars['Float'],
  originalPurchasePrice: Scalars['Float'],
};

export type LandSaleElectionInput = {
  landAssetId?: Maybe<Scalars['ID']>,
  landConfigId?: Maybe<Scalars['ID']>,
  salePrice: Scalars['Float'],
  originalPurchasePrice: Scalars['Float'],
};

export type LastNotificationCheck = {
   __typename?: 'LastNotificationCheck',
  id: Scalars['ID'],
  teamId: Scalars['ID'],
  userId: Scalars['ID'],
  lastCheckedTimestamp: Scalars['Float'],
};

export type License = {
   __typename?: 'License',
  id: Scalars['ID'],
  key: Scalars['String'],
  price?: Maybe<Scalars['Float']>,
  revokedTimestamp?: Maybe<Scalars['Float']>,
  isBanned: Scalars['Boolean'],
  purchaseNote?: Maybe<Scalars['String']>,
  licenseType?: Maybe<UserTypeEnum>,
  email?: Maybe<Scalars['String']>,
  studentPrice?: Maybe<Scalars['Float']>,
  school?: Maybe<Scalars['String']>,
  licenseStart?: Maybe<Scalars['Float']>,
  licenseEnd?: Maybe<Scalars['Float']>,
  paid?: Maybe<Scalars['Boolean']>,
  autoRenew?: Maybe<Scalars['Boolean']>,
  numAllowedGames?: Maybe<Scalars['Int']>,
  user?: Maybe<User>,
  warningNote?: Maybe<Scalars['String']>,
  createdAt?: Maybe<Scalars['String']>,
  professorKey?: Maybe<Scalars['String']>,
  semesterId?: Maybe<Scalars['String']>,
};

export type LicenseInput = {
  id?: Maybe<Scalars['ID']>,
  school?: Maybe<Scalars['String']>,
  licenseStart?: Maybe<Scalars['Float']>,
  licenseEnd?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  numAllowedGames?: Maybe<Scalars['Int']>,
  studentPrice?: Maybe<Scalars['Float']>,
  revokedTimestamp?: Maybe<Scalars['Float']>,
  isBanned?: Maybe<Scalars['Boolean']>,
  isWarningLicense?: Maybe<Scalars['Boolean']>,
};

export enum LicenseStatusEnum {
  Revoked = 'REVOKED',
  Expired = 'EXPIRED',
  NonExistant = 'NON_EXISTANT',
  Valid = 'VALID'
}

export type MarketCalc = {
   __typename?: 'MarketCalc',
  marketCalcId: Scalars['ID'],
  roundIndex: Scalars['Int'],
  roundId?: Maybe<Scalars['ID']>,
  hasCompleted: Scalars['Boolean'],
};

export type Message = {
   __typename?: 'Message',
  id?: Maybe<Scalars['ID']>,
  text: Scalars['String'],
  timeSent: Scalars['Float'],
  teamIds: Array<Scalars['ID']>,
  messageType: MessageTypeEnum,
  sender?: Maybe<User>,
  priority: MessagePriorityEnum,
  hasBeenRead: Scalars['Boolean'],
  roundConfigId?: Maybe<Scalars['ID']>,
};

export enum MessagePriorityEnum {
  AppOnly = 'APP_ONLY',
  Regular = 'REGULAR',
  Critical = 'CRITICAL',
  Nuclear = 'NUCLEAR'
}

export enum MessageTypeEnum {
  ManualFromProfessor = 'MANUAL_FROM_PROFESSOR',
  ManualFromAdmin = 'MANUAL_FROM_ADMIN',
  AuditLog = 'AUDIT_LOG',
  Gameplay = 'GAMEPLAY',
  Reminder = 'REMINDER'
}

export type Mutation = {
   __typename?: 'Mutation',
  productionDepreciationFix?: Maybe<Scalars['String']>,
  askGamesToMoveForward?: Maybe<CheckGameFlowsResult>,
  importCourse?: Maybe<Course>,
  importCourseTemplate?: Maybe<CourseTemplate>,
  updateCourseTemplate?: Maybe<Array<Maybe<CourseTemplate>>>,
  adminCreateOrUpdateLicense?: Maybe<License>,
  createSemester?: Maybe<Semester>,
  editSemester?: Maybe<Semester>,
  submitRoundElections?: Maybe<RoundElection>,
  submitIncomeStatement?: Maybe<IncomeStatement>,
  submitBalanceSheet?: Maybe<BalanceSheet>,
  submitCashFlow?: Maybe<CashFlow>,
  triggerMarketCalc?: Maybe<Scalars['Boolean']>,
  modifyRoundTimings?: Maybe<Semester>,
  toggleMaintenanceMode?: Maybe<SystemStatusResponse>,
  resetGameToRoundWithRoundLength?: Maybe<Semester>,
  resetGameToRoundWithTimestamps?: Maybe<Semester>,
  resetGameToBeforeLastMarketCalc?: Maybe<Semester>,
  removePlayer?: Maybe<RemovePlayerResponse>,
  prepAndRunSimulation?: Maybe<Semester>,
  throwError?: Maybe<Error>,
  switchTeams?: Maybe<Array<Maybe<Team>>>,
  updateSemesterRoundTimings?: Maybe<Semester>,
  extendGame?: Maybe<Semester>,
  toggleSemesterIsPaused?: Maybe<Semester>,
  sendMessage?: Maybe<Message>,
  updateLastNotificationCheck?: Maybe<LastNotificationCheck>,
  updateUserSettings?: Maybe<User>,
  deleteCourseTemplate?: Maybe<Array<Maybe<CourseTemplate>>>,
  removeStudentFromTeam?: Maybe<Array<Maybe<Team>>>,
};


export type MutationImportCourseArgs = {
  courseInput: CourseInput
};


export type MutationImportCourseTemplateArgs = {
  courseTemplateJSON: CourseTemplateInput,
  professorId?: Maybe<Scalars['ID']>,
  name: Scalars['String'],
  description: Scalars['String']
};


export type MutationUpdateCourseTemplateArgs = {
  courseTemplateId: Scalars['ID'],
  courseTemplateJSON?: Maybe<CourseTemplateInput>,
  professorId?: Maybe<Scalars['ID']>,
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  isLive?: Maybe<Scalars['Boolean']>
};


export type MutationAdminCreateOrUpdateLicenseArgs = {
  email: Scalars['String'],
  licenseType: Scalars['String'],
  licenseInput?: Maybe<LicenseInput>
};


export type MutationCreateSemesterArgs = {
  input: SemesterInput
};


export type MutationEditSemesterArgs = {
  input: SemesterInput
};


export type MutationSubmitRoundElectionsArgs = {
  input: RoundElectionInput
};


export type MutationSubmitIncomeStatementArgs = {
  input: IncomeStatementInput
};


export type MutationSubmitBalanceSheetArgs = {
  input: BalanceSheetInput
};


export type MutationSubmitCashFlowArgs = {
  input: CashFlowInput
};


export type MutationTriggerMarketCalcArgs = {
  semesterId: Scalars['ID'],
  roundConfigId: Scalars['ID']
};


export type MutationModifyRoundTimingsArgs = {
  semesterId: Scalars['ID'],
  secondsPerRound: Scalars['Int'],
  newStartSeconds?: Maybe<Scalars['Float']>
};


export type MutationResetGameToRoundWithRoundLengthArgs = {
  semesterId: Scalars['ID'],
  roundToResetTo: Scalars['Int'],
  roundStartSeconds?: Maybe<Scalars['Float']>,
  secondsPerRound: Scalars['Int']
};


export type MutationResetGameToRoundWithTimestampsArgs = {
  semesterId: Scalars['ID'],
  roundToResetTo: Scalars['Int'],
  roundTimingsToReset: Array<Maybe<RoundTimingInput>>,
  keepElections?: Maybe<Scalars['Boolean']>
};


export type MutationResetGameToBeforeLastMarketCalcArgs = {
  semesterId: Scalars['ID']
};


export type MutationRemovePlayerArgs = {
  studentId: Scalars['ID'],
  teamId: Scalars['ID']
};


export type MutationPrepAndRunSimulationArgs = {
  input: SimulationInput
};


export type MutationSwitchTeamsArgs = {
  semesterId: Scalars['ID'],
  studentToMoveId: Scalars['ID'],
  oldTeamId: Scalars['ID'],
  newTeamId: Scalars['ID']
};


export type MutationUpdateSemesterRoundTimingsArgs = {
  semesterId: Scalars['ID'],
  roundTimings: Array<Maybe<RoundTimingInput>>
};


export type MutationExtendGameArgs = {
  semesterId: Scalars['ID'],
  numNewRounds: Scalars['Int']
};


export type MutationToggleSemesterIsPausedArgs = {
  semesterId: Scalars['ID']
};


export type MutationSendMessageArgs = {
  input: SendMessageInput
};


export type MutationUpdateLastNotificationCheckArgs = {
  teamId: Scalars['ID']
};


export type MutationUpdateUserSettingsArgs = {
  userSettings: UserSettingsInput
};


export type MutationDeleteCourseTemplateArgs = {
  courseTemplateId: Scalars['ID'],
  professorId?: Maybe<Scalars['ID']>
};


export type MutationRemoveStudentFromTeamArgs = {
  studentId: Scalars['ID'],
  teamId: Scalars['ID']
};

export enum NormalBalance {
  Debit = 'DEBIT',
  Credit = 'CREDIT',
  Special = 'SPECIAL'
}

export type PreloadAssets = {
   __typename?: 'PreloadAssets',
  lands: Array<Maybe<PreloadLandAsset>>,
  buildings: Array<Maybe<PreloadBuildingAsset>>,
  equipments: Array<Maybe<PreloadEquipmentAsset>>,
  storeFurnishings: Array<Maybe<PreloadStoreFurnishingAsset>>,
  debts: Array<Maybe<PreloadDebtLiability>>,
  products: Array<Maybe<PreloadInventory>>,
};

export type PreloadAssetsInput = {
  lands?: Maybe<Array<Maybe<LandAssetInput>>>,
  buildings?: Maybe<Array<Maybe<BuildingAssetInput>>>,
  equipments?: Maybe<Array<Maybe<EquipmentAssetInput>>>,
  storeFurnishings?: Maybe<Array<Maybe<StoreFurnishingAssetInput>>>,
  debts?: Maybe<Array<Maybe<DebtLiabilityInput>>>,
  products?: Maybe<Array<Maybe<ProductInventoryInput>>>,
};

export type PreloadBuildingAsset = {
   __typename?: 'PreloadBuildingAsset',
  name: Scalars['String'],
  land: Scalars['String'],
  totalCapacity: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  depreciationMethod: Scalars['String'],
  usefulLife: Scalars['Int'],
};

export type PreloadDebtLiability = {
   __typename?: 'PreloadDebtLiability',
  name: Scalars['String'],
  originalRate: Scalars['Float'],
  originalTerm: Scalars['Int'],
  originalPrincipal: Scalars['Float'],
};

export type PreloadEquipmentAsset = {
   __typename?: 'PreloadEquipmentAsset',
  name: Scalars['String'],
  building: Scalars['String'],
  totalCapacity: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  depreciationMethod: Scalars['String'],
  usefulLife: Scalars['Int'],
};

export type PreloadInventory = {
   __typename?: 'PreloadInventory',
  gameProductName: Scalars['String'],
  inventoryAmount: Scalars['Int'],
  costPerUnit: Scalars['Float'],
};

export type PreloadLandAsset = {
   __typename?: 'PreloadLandAsset',
  name: Scalars['String'],
  totalCapacity: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
};

export type PreloadStoreFurnishingAsset = {
   __typename?: 'PreloadStoreFurnishingAsset',
  name: Scalars['String'],
  building: Scalars['String'],
  totalCapacity: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  depreciationMethod: Scalars['String'],
  usefulLife: Scalars['Int'],
};

export type ProductConfig = {
   __typename?: 'ProductConfig',
  id?: Maybe<Scalars['ID']>,
  gameProductId?: Maybe<Scalars['ID']>,
  productionCost: Scalars['Float'],
  demandSlope: Scalars['Float'],
  demandIntercept: Scalars['Float'],
};

export type ProductConfigInput = {
  id?: Maybe<Scalars['ID']>,
  gameProduct?: Maybe<Scalars['String']>,
  gameProductId?: Maybe<Scalars['ID']>,
  productionCost: Scalars['Float'],
  demandSlope: Scalars['Float'],
  demandIntercept: Scalars['Float'],
};

export type ProductElection = {
   __typename?: 'ProductElection',
  productConfigId: Scalars['ID'],
  gameProductId: Scalars['ID'],
  quantityOffered: Scalars['Int'],
  offerPrice: Scalars['Float'],
  numUnitsToAdvertise: Scalars['Int'],
};

export type ProductElectionInput = {
  productConfigId: Scalars['ID'],
  gameProductId: Scalars['ID'],
  quantityOffered: Scalars['Int'],
  offerPrice: Scalars['Float'],
  numUnitsToAdvertise: Scalars['Int'],
};

export type ProductInventory = {
   __typename?: 'ProductInventory',
  id?: Maybe<Scalars['ID']>,
  team?: Maybe<Team>,
  gameProduct?: Maybe<GameProduct>,
  roundConfigId?: Maybe<Scalars['ID']>,
  productConfigId?: Maybe<Scalars['ID']>,
  originalInventoryAmount?: Maybe<Scalars['Int']>,
  outstandingInventoryAmount?: Maybe<Scalars['Int']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  inventoryChanges?: Maybe<Array<Maybe<InventoryChange>>>,
};

export type ProductInventoryInput = {
  gameProductName: Scalars['String'],
  inventoryAmount: Scalars['Int'],
  costPerUnit: Scalars['Float'],
};

export type ProductInventoryReport = {
   __typename?: 'ProductInventoryReport',
  team?: Maybe<Team>,
  gameProduct?: Maybe<GameProduct>,
  inventoryAmount?: Maybe<Scalars['Int']>,
};

export type ProfessorInput = {
  id?: Maybe<Scalars['ID']>,
  email: Scalars['String'],
  firstname: Scalars['String'],
  lastname: Scalars['String'],
};

export type Query = {
   __typename?: 'Query',
  course?: Maybe<Course>,
  courses?: Maybe<Array<Maybe<Course>>>,
  currentAssets?: Maybe<CurrentAssets>,
  studentSemesters?: Maybe<Array<Maybe<Semester>>>,
  professorSemesters?: Maybe<Array<Maybe<Semester>>>,
  semesterByCode?: Maybe<Semester>,
  election?: Maybe<RoundElection>,
  elections?: Maybe<Array<Maybe<RoundElection>>>,
  team?: Maybe<Team>,
  getCurrentLicense?: Maybe<License>,
  adminLicenses?: Maybe<Array<Maybe<UserLicenseStatus>>>,
  professorLicenses?: Maybe<Array<Maybe<UserLicenseStatus>>>,
  studentLicenses?: Maybe<Array<Maybe<UserLicenseStatus>>>,
  professorTeams?: Maybe<Array<Maybe<Team>>>,
  gameState?: Maybe<GameState>,
  incomeStatement?: Maybe<IncomeStatement>,
  balanceSheet?: Maybe<BalanceSheet>,
  cashFlow?: Maybe<CashFlow>,
  salesReport?: Maybe<Array<Maybe<SalesReportEntry>>>,
  gradingReport?: Maybe<GradingReport>,
  remainingInventoryCosts?: Maybe<Array<Maybe<RoundInventoryCosts>>>,
  scoreboardData?: Maybe<ScoreboardData>,
  systemStatus?: Maybe<SystemStatusResponse>,
  teamInfo?: Maybe<Array<Maybe<Team>>>,
  generateRoundTimings?: Maybe<Array<Maybe<RoundTiming>>>,
  exportSimulationDataFromGame?: Maybe<SimulationData>,
  exportGameResults?: Maybe<GameResults>,
  generalLedger?: Maybe<Array<Maybe<GeneralLedgerTableEntry>>>,
  journalEntriesAndTAccounts?: Maybe<JournalEntriesAndTAccountsResponse>,
  validateAdminLicense?: Maybe<License>,
  stockTicker?: Maybe<Array<Maybe<StockTickerDataPoint>>>,
  getStockPriceForTeam?: Maybe<TeamStockResponse>,
  userByEmail?: Maybe<User>,
  financialRatios?: Maybe<Array<Maybe<FinancialRatio>>>,
  autoScheduleRoundTimings?: Maybe<Array<Maybe<RoundTiming>>>,
  validateRoundTimings?: Maybe<Array<Maybe<RoundTiming>>>,
  getMessages?: Maybe<Array<Maybe<Message>>>,
  getCustomLabels?: Maybe<Array<Maybe<CustomLabel>>>,
  courseTemplates?: Maybe<Array<Maybe<CourseTemplate>>>,
  courseTemplateAsInputString?: Maybe<Scalars['String']>,
  courseAsCourseTemplate?: Maybe<Scalars['String']>,
};


export type QueryCourseArgs = {
  id: Scalars['ID']
};


export type QueryCurrentAssetsArgs = {
  teamId: Scalars['String']
};


export type QuerySemesterByCodeArgs = {
  semesterCode?: Maybe<Scalars['String']>
};


export type QueryElectionArgs = {
  roundConfigId: Scalars['ID'],
  teamId: Scalars['String']
};


export type QueryElectionsArgs = {
  teamId: Scalars['String']
};


export type QueryTeamArgs = {
  teamId: Scalars['ID']
};


export type QueryGetCurrentLicenseArgs = {
  userEmail: Scalars['String']
};


export type QueryProfessorTeamsArgs = {
  semesterId: Scalars['ID']
};


export type QueryGameStateArgs = {
  semesterId: Scalars['ID']
};


export type QueryIncomeStatementArgs = {
  roundConfigId: Scalars['ID'],
  teamId: Scalars['String']
};


export type QueryBalanceSheetArgs = {
  roundConfigId: Scalars['ID'],
  teamId: Scalars['String']
};


export type QueryCashFlowArgs = {
  roundConfigId?: Maybe<Scalars['ID']>,
  teamId: Scalars['String']
};


export type QuerySalesReportArgs = {
  roundConfigId: Scalars['ID'],
  teamId: Scalars['ID']
};


export type QueryGradingReportArgs = {
  roundConfigId: Scalars['ID'],
  teamId: Scalars['String']
};


export type QueryRemainingInventoryCostsArgs = {
  teamId: Scalars['String'],
  roundConfigId: Scalars['ID']
};


export type QueryScoreboardDataArgs = {
  semesterId: Scalars['ID']
};


export type QueryTeamInfoArgs = {
  semesterId: Scalars['ID']
};


export type QueryGenerateRoundTimingsArgs = {
  courseId: Scalars['ID'],
  startTime: Scalars['Int'],
  timezone: Scalars['String']
};


export type QueryExportSimulationDataFromGameArgs = {
  semesterId: Scalars['ID']
};


export type QueryExportGameResultsArgs = {
  semesterId: Scalars['ID']
};


export type QueryGeneralLedgerArgs = {
  semesterId: Scalars['ID']
};


export type QueryJournalEntriesAndTAccountsArgs = {
  roundConfigId: Scalars['ID'],
  teamId: Scalars['ID']
};


export type QueryValidateAdminLicenseArgs = {
  userEmail: Scalars['String']
};


export type QueryStockTickerArgs = {
  semesterId: Scalars['ID'],
  roundConfigId: Scalars['ID']
};


export type QueryGetStockPriceForTeamArgs = {
  roundConfigId: Scalars['ID'],
  teamId: Scalars['ID']
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']
};


export type QueryFinancialRatiosArgs = {
  semesterId: Scalars['ID'],
  teamId?: Maybe<Scalars['ID']>,
  roundConfigId: Scalars['ID']
};


export type QueryAutoScheduleRoundTimingsArgs = {
  semesterId?: Maybe<Scalars['ID']>,
  courseId?: Maybe<Scalars['ID']>,
  roundToBeginGeneratingNewTimings: Scalars['Int'],
  passedInRoundTiming: RoundTimingInput,
  timezone: Scalars['String']
};


export type QueryValidateRoundTimingsArgs = {
  semesterId?: Maybe<Scalars['ID']>,
  courseId?: Maybe<Scalars['ID']>,
  roundTimings: Array<Maybe<RoundTimingInput>>,
  timezone: Scalars['String']
};


export type QueryGetMessagesArgs = {
  teamId: Scalars['ID']
};


export type QueryGetCustomLabelsArgs = {
  semesterId: Scalars['ID']
};


export type QueryCourseTemplatesArgs = {
  professorId?: Maybe<Scalars['ID']>
};


export type QueryCourseTemplateAsInputStringArgs = {
  courseTemplateId: Scalars['ID']
};


export type QueryCourseAsCourseTemplateArgs = {
  courseId: Scalars['ID']
};

export type RemainingInventoryCosts = {
   __typename?: 'RemainingInventoryCosts',
  gameProductId: Scalars['ID'],
  gameProductName: Scalars['String'],
  remainingUnits?: Maybe<Scalars['Float']>,
  cost?: Maybe<Scalars['Float']>,
};

export type RemovePlayerResponse = {
   __typename?: 'RemovePlayerResponse',
  message: Scalars['String'],
};

export type ResultingBs = {
   __typename?: 'ResultingBS',
  team: Scalars['String'],
  roundConfigId: Scalars['String'],
  cash?: Maybe<Scalars['Float']>,
  inventory?: Maybe<Scalars['Float']>,
  equipment?: Maybe<Scalars['Float']>,
  equipmentDepreciation?: Maybe<Scalars['Float']>,
  buildings?: Maybe<Scalars['Float']>,
  buildingsDepreciation?: Maybe<Scalars['Float']>,
  land?: Maybe<Scalars['Float']>,
  totalAssets?: Maybe<Scalars['Float']>,
  loanPayable?: Maybe<Scalars['Float']>,
  totalLiabilities?: Maybe<Scalars['Float']>,
  commonStock?: Maybe<Scalars['Float']>,
  retainedEarnings?: Maybe<Scalars['Float']>,
  totalLiabilitiesAndEquity?: Maybe<Scalars['Float']>,
};

export type ResultingBuilding = {
   __typename?: 'ResultingBuilding',
  team: Scalars['String'],
  buildingConfigId: Scalars['String'],
  totalCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  roundPurchasedIndex: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  salePrice?: Maybe<Scalars['Float']>,
  depreciationMethod: Scalars['String'],
  annualDepreciationPercent: Scalars['Float'],
  expiringRoundId?: Maybe<Scalars['String']>,
  depreciationChanges: Array<Maybe<ResultingDepreciationChange>>,
};

export type ResultingCf = {
   __typename?: 'ResultingCF',
  team?: Maybe<Scalars['String']>,
  roundConfigId: Scalars['String'],
  operatingActivitiesSales?: Maybe<Scalars['Float']>,
  operatingActivitiesPurchasedInventory?: Maybe<Scalars['Float']>,
  operatingActivitiesPaidAdvertising?: Maybe<Scalars['Float']>,
  operatingActivitiesSalesReturns?: Maybe<Scalars['Float']>,
  operatingActivitiesIncomeTaxesPaid?: Maybe<Scalars['Float']>,
  operatingActivitiesInterestPaid?: Maybe<Scalars['Float']>,
  operatingActivitiesTotal?: Maybe<Scalars['Float']>,
  investingActivitiesInflowEquipment?: Maybe<Scalars['Float']>,
  investingActivitiesInflowBuildings?: Maybe<Scalars['Float']>,
  investingActivitiesInflowLand?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowEquipment?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowBuildings?: Maybe<Scalars['Float']>,
  investingActivitiesOutflowLand?: Maybe<Scalars['Float']>,
  investingActivitiesTotal?: Maybe<Scalars['Float']>,
  financingActivitiesCapital?: Maybe<Scalars['Float']>,
  financingActivitiesLoanBorrow?: Maybe<Scalars['Float']>,
  financingActivitiesLoanRepay?: Maybe<Scalars['Float']>,
  financingActivitiesTotal?: Maybe<Scalars['Float']>,
  netCash?: Maybe<Scalars['Float']>,
  beginningOfRound?: Maybe<Scalars['Float']>,
  endOfRound?: Maybe<Scalars['Float']>,
};

export type ResultingDebt = {
   __typename?: 'ResultingDebt',
  team: Scalars['String'],
  debtConfigId?: Maybe<Scalars['String']>,
  originalRate: Scalars['Float'],
  originalTerm: Scalars['Int'],
  originalPrincipal: Scalars['Float'],
  roundBorrowedIndex: Scalars['Int'],
  repayments: Array<Maybe<ResultingDebtRepayment>>,
  repaymentRoundId?: Maybe<Scalars['String']>,
};

export type ResultingDebtRepayment = {
   __typename?: 'ResultingDebtRepayment',
  timeStamp: Scalars['String'],
  repaymentRoundId: Scalars['String'],
  repaymentAmount: Scalars['Float'],
};

export type ResultingDepreciationChange = {
   __typename?: 'ResultingDepreciationChange',
  timeStamp: Scalars['String'],
  roundConfigId: Scalars['String'],
  depreciationExpense: Scalars['Float'],
};

export type ResultingEquipment = {
   __typename?: 'ResultingEquipment',
  team: Scalars['String'],
  equipmentConfigId: Scalars['ID'],
  totalCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  roundPurchasedIndex: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  salePrice?: Maybe<Scalars['Float']>,
  depreciationMethod?: Maybe<Scalars['String']>,
  annualDepreciationPercent?: Maybe<Scalars['Float']>,
  expiringRoundId?: Maybe<Scalars['String']>,
  depreciationChanges: Array<Maybe<ResultingDepreciationChange>>,
};

export type ResultingGl = {
   __typename?: 'ResultingGL',
  roundConfigId: Scalars['String'],
  roundIndex: Scalars['Int'],
  team: Scalars['String'],
  amount: Scalars['Float'],
  account: Account,
};

export type ResultingInventory = {
   __typename?: 'ResultingInventory',
  team: Scalars['String'],
  gameProduct: Scalars['String'],
  roundConfigId: Scalars['String'],
  productConfigId: Scalars['String'],
  originalInventoryAmount: Scalars['Int'],
  costPerUnit: Scalars['Float'],
  inventoryChanges: Array<Maybe<ResultingInventoryChange>>,
};

export type ResultingInventoryChange = {
   __typename?: 'ResultingInventoryChange',
  timeStamp: Scalars['String'],
  roundConfigId: Scalars['String'],
  inventoryAmount: Scalars['Int'],
};

export type ResultingIs = {
   __typename?: 'ResultingIS',
  team: Scalars['String'],
  roundConfigId: Scalars['String'],
  revenue?: Maybe<Scalars['Float']>,
  returns?: Maybe<Scalars['Float']>,
  net?: Maybe<Scalars['Float']>,
  costOfGoodsSold?: Maybe<Scalars['Float']>,
  grossProfit?: Maybe<Scalars['Float']>,
  adExpense?: Maybe<Scalars['Float']>,
  depreciationExpense?: Maybe<Scalars['Float']>,
  interest?: Maybe<Scalars['Float']>,
  gainOnAssetSales?: Maybe<Scalars['Float']>,
  accountsReceivable?: Maybe<Scalars['Float']>,
  badDebtExpense?: Maybe<Scalars['Float']>,
  total?: Maybe<Scalars['Float']>,
  incomeTax?: Maybe<Scalars['Float']>,
  netIncome?: Maybe<Scalars['Float']>,
};

export type ResultingLand = {
   __typename?: 'ResultingLand',
  team: Scalars['String'],
  landConfigId: Scalars['String'],
  totalCapacity: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  salePrice?: Maybe<Scalars['Float']>,
  roundPurchasedIndex: Scalars['Int'],
};

export type ResultingSalesReport = {
   __typename?: 'ResultingSalesReport',
  roundConfigId: Scalars['String'],
  roundIndex: Scalars['Int'],
  team: Scalars['String'],
  gameProduct: Scalars['String'],
  offerPrice: Scalars['Float'],
  perceivedPrice: Scalars['Float'],
  unitsSold: Scalars['Int'],
  unitsOffered: Scalars['Int'],
  isAdvertised: Scalars['Boolean'],
  isInventory: Scalars['Boolean'],
};

export type ResultingStoreFurnishing = {
   __typename?: 'ResultingStoreFurnishing',
  team: Scalars['String'],
  furnishingConfigId: Scalars['ID'],
  totalCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  roundPurchasedIndex: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  salePrice?: Maybe<Scalars['Float']>,
  depreciationMethod?: Maybe<Scalars['String']>,
  annualDepreciationPercent?: Maybe<Scalars['Float']>,
  expiringRoundId?: Maybe<Scalars['String']>,
  depreciationChanges: Array<Maybe<ResultingDepreciationChange>>,
};

export type RoundConfig = {
   __typename?: 'RoundConfig',
  id?: Maybe<Scalars['ID']>,
  salesReturnsPercentLowerBound: Scalars['Float'],
  salesReturnsPercentUpperBound: Scalars['Float'],
  buildings?: Maybe<Array<Maybe<BuildingConfig>>>,
  equipments?: Maybe<Array<Maybe<EquipmentConfig>>>,
  lands?: Maybe<Array<Maybe<LandConfig>>>,
  storeFurnishings?: Maybe<Array<Maybe<StoreFurnishingConfig>>>,
  debts?: Maybe<Array<Maybe<DebtConfig>>>,
  products?: Maybe<Array<Maybe<ProductConfig>>>,
  isStockTradingEnabled: Scalars['Boolean'],
  bonds: BondsConfig,
};

export type RoundConfigInput = {
  id?: Maybe<Scalars['ID']>,
  roundNum: Scalars['Int'],
  salesReturnsPercentLowerBound: Scalars['Float'],
  salesReturnsPercentUpperBound: Scalars['Float'],
  buildings: Array<Maybe<BuildingConfigInput>>,
  equipments: Array<Maybe<EquipmentConfigInput>>,
  lands: Array<Maybe<LandConfigInput>>,
  storeFurnishings: Array<Maybe<StoreFurnishingConfigInput>>,
  debts: Array<Maybe<DebtConfigInput>>,
  products: Array<Maybe<ProductConfigInput>>,
  isStockTradingEnabled: Scalars['Boolean'],
  bonds: BondsConfigInput,
};

export type RoundElection = {
   __typename?: 'RoundElection',
  id: Scalars['ID'],
  semester?: Maybe<Semester>,
  team?: Maybe<Team>,
  roundConfigId: Scalars['ID'],
  buildingPurchases: Array<BuildingPurchaseElection>,
  buildingSales: Array<BuildingSaleElection>,
  equipmentPurchases: Array<EquipmentPurchaseElection>,
  equipmentSales: Array<EquipmentSaleElection>,
  landPurchases: Array<LandPurchaseElection>,
  landSales: Array<LandSaleElection>,
  storeFurnishingPurchases: Array<StoreFurnishingPurchaseElection>,
  storeFurnishingSales: Array<StoreFurnishingSaleElection>,
  debtsBorrowed: Array<DebtBorrowElection>,
  debtsRepayed: Array<DebtRepaymentElection>,
  productElections: Array<ProductElection>,
  stockSales: Array<StockSaleElection>,
  bondSales: Array<BondSaleElection>,
  submittedBy?: Maybe<User>,
  createdAt?: Maybe<Scalars['String']>,
};

export type RoundElectionInput = {
  teamId?: Maybe<Scalars['ID']>,
  roundConfigId?: Maybe<Scalars['ID']>,
  buildingPurchases: Array<BuildingPurchaseElectionInput>,
  buildingSales: Array<BuildingSaleElectionInput>,
  equipmentPurchases: Array<EquipmentPurchaseElectionInput>,
  equipmentSales: Array<EquipmentSaleElectionInput>,
  landPurchases: Array<LandPurchaseElectionInput>,
  landSales: Array<LandSaleElectionInput>,
  storeFurnishingPurchases: Array<StoreFurnishingPurchaseElectionInput>,
  storeFurnishingSales: Array<StoreFurnishingSaleElectionInput>,
  debtsBorrowed: Array<DebtBorrowElectionInput>,
  debtsRepayed: Array<DebtRepaymentElectionInput>,
  productElections: Array<ProductElectionInput>,
  stockSales: Array<StockSaleElectionInput>,
  bondSales: Array<BondSaleElectionInput>,
};

export type RoundInventoryCosts = {
   __typename?: 'RoundInventoryCosts',
  roundIndex: Scalars['Int'],
  roundConfigId: Scalars['ID'],
  inventoryCosts: Array<Maybe<RemainingInventoryCosts>>,
};

export enum RoundModuleDisplaySettingEnum {
  Submit = 'SUBMIT',
  ShowForAllRounds = 'SHOW_FOR_ALL_ROUNDS',
  ShowForPastRounds = 'SHOW_FOR_PAST_ROUNDS',
  Off = 'OFF'
}

export type RoundSalesReturn = {
   __typename?: 'RoundSalesReturn',
  teamId: Scalars['ID'],
  roundConfigId: Scalars['ID'],
  assignedSalesReturnsPercentage: Scalars['Float'],
};

export type RoundTiming = {
   __typename?: 'RoundTiming',
  roundConfigId: Scalars['ID'],
  electionsOpen: Scalars['Float'],
  electionsDeadline: Scalars['Float'],
  secondSubmissionDeadline: Scalars['Float'],
  gradeViewingDeadline: Scalars['Float'],
  hasCalculatedMarket: Scalars['Boolean'],
  hasGraded: Scalars['Boolean'],
  marketCalcId?: Maybe<Scalars['ID']>,
};

export type RoundTimingInput = {
  electionsOpen: Scalars['Float'],
  electionsDeadline: Scalars['Float'],
  secondSubmissionDeadline: Scalars['Float'],
  gradeViewingDeadline?: Maybe<Scalars['Float']>,
};

export type SalesReportEntry = {
   __typename?: 'SalesReportEntry',
  id?: Maybe<Scalars['ID']>,
  roundConfigId?: Maybe<Scalars['ID']>,
  roundIndex?: Maybe<Scalars['Int']>,
  team?: Maybe<Team>,
  gameProduct?: Maybe<GameProduct>,
  offerPrice?: Maybe<Scalars['Float']>,
  perceivedPrice?: Maybe<Scalars['Float']>,
  unitsSold?: Maybe<Scalars['Int']>,
  unitsOffered?: Maybe<Scalars['Int']>,
  isAdvertised?: Maybe<Scalars['Boolean']>,
  isInventory?: Maybe<Scalars['Boolean']>,
  previousRoundAR?: Maybe<Scalars['Float']>,
};

export type ScoreboardData = {
   __typename?: 'ScoreboardData',
  semesterName?: Maybe<Scalars['String']>,
  numRoundsCompleted?: Maybe<Scalars['Int']>,
  numTotalRounds?: Maybe<Scalars['Int']>,
  rounds?: Maybe<Array<Maybe<ScoreboardRound>>>,
};

export type ScoreboardRound = {
   __typename?: 'ScoreboardRound',
  roundId?: Maybe<Scalars['ID']>,
  roundNum: Scalars['Int'],
  teamDatas: Array<Maybe<ScoreboardTeamDataPoint>>,
};

export type ScoreboardTeamDataPoint = {
   __typename?: 'ScoreboardTeamDataPoint',
  teamId: Scalars['ID'],
  teamName: Scalars['String'],
  teamColorCode: Scalars['String'],
  currentRoundIncome: Scalars['Float'],
  previousRoundsTotalNetIncome: Scalars['Float'],
};

export type Semester = {
   __typename?: 'Semester',
  id: Scalars['ID'],
  course?: Maybe<Course>,
  name?: Maybe<Scalars['String']>,
  year?: Maybe<Scalars['Int']>,
  season?: Maybe<SemesterSeason>,
  startTime: Scalars['Float'],
  endTime: Scalars['Float'],
  numTeams: Scalars['Int'],
  numStudentsPerTeam: Scalars['Int'],
  onboardCode: Scalars['String'],
  professors: Array<Maybe<User>>,
  teams?: Maybe<Array<Maybe<Team>>>,
  roundTimings: Array<Maybe<RoundTiming>>,
  teamColors?: Maybe<Array<Maybe<TeamColor>>>,
  teamSalesReturns: Array<Maybe<Array<Maybe<RoundSalesReturn>>>>,
  timezone: Scalars['String'],
  useFlowMode: Scalars['Boolean'],
  gameConfig: GameConfig,
  hasDistributedPreloadedAssets: Scalars['Boolean'],
  currentRoundIndex?: Maybe<Scalars['Int']>,
  roundNum?: Maybe<Scalars['Int']>,
  electionsDue?: Maybe<Scalars['Float']>,
  financialsDue?: Maybe<Scalars['Float']>,
  currentGamePhase?: Maybe<GameRoundPhase>,
  isActive: Scalars['Boolean'],
  isArchived: Scalars['Boolean'],
  studentPrice?: Maybe<Scalars['Float']>,
  professorLicenseKey?: Maybe<Scalars['String']>,
  isPaused: Scalars['Boolean'],
};

export type SemesterInput = {
  id?: Maybe<Scalars['ID']>,
  name?: Maybe<Scalars['String']>,
  year?: Maybe<Scalars['Int']>,
  season?: Maybe<SemesterSeason>,
  startTime?: Maybe<Scalars['Float']>,
  numTeams?: Maybe<Scalars['Int']>,
  numStudentsPerTeam?: Maybe<Scalars['Int']>,
  courseTemplateId?: Maybe<Scalars['ID']>,
  professorIds?: Maybe<Array<Maybe<Scalars['String']>>>,
  useFlowMode?: Maybe<Scalars['Boolean']>,
  timezone?: Maybe<Scalars['String']>,
  archive?: Maybe<Scalars['Boolean']>,
  delete?: Maybe<Scalars['Boolean']>,
};

export enum SemesterSeason {
  Fall = 'FALL',
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

export type SendMessageInput = {
  text: Scalars['String'],
  teamIds: Array<Scalars['ID']>,
  priority: MessagePriorityEnum,
};

export type SimulationData = {
   __typename?: 'SimulationData',
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  courseId: Scalars['ID'],
  teamInputs: Array<SimulationTeam>,
};

export type SimulationDataInput = {
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  teamInputs: Array<SimulationTeamInput>,
};

export type SimulationInput = {
  dataFileName: Scalars['String'],
  courseId: Scalars['ID'],
  roundToSeedTo: Scalars['Int'],
  phaseToSeedTo: Scalars['String'],
  semesterName: Scalars['String'],
  timezone?: Maybe<Scalars['String']>,
  secondsPerRound?: Maybe<Scalars['Int']>,
  useFlowMode: Scalars['Boolean'],
  studentEmails?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type SimulationSheet = {
   __typename?: 'SimulationSheet',
  incomeStatement?: Maybe<IncomeStatement>,
  balanceSheet?: Maybe<BalanceSheet>,
  cashFlow?: Maybe<CashFlow>,
};

export type SimulationSheetInput = {
  incomeStatement?: Maybe<IncomeStatementInput>,
  balanceSheet?: Maybe<BalanceSheetInput>,
  cashFlow?: Maybe<CashFlowInput>,
};

export type SimulationTeam = {
   __typename?: 'SimulationTeam',
  teamName: Scalars['String'],
  roundSalesReturns?: Maybe<Array<Maybe<Scalars['Float']>>>,
  elections: Array<RoundElection>,
  sheets: Array<SimulationSheet>,
};

export type SimulationTeamInput = {
  teamName: Scalars['String'],
  stockSymbol: Scalars['String'],
  roundSalesReturns?: Maybe<Array<Maybe<Scalars['Float']>>>,
  elections: Array<Maybe<RoundElectionInput>>,
  sheets: Array<Maybe<SimulationSheetInput>>,
};

export type StockConfig = {
   __typename?: 'StockConfig',
  teamStartingStockPrice: Scalars['Float'],
  initialOfferingNumShares: Scalars['Int'],
  totalSellableSharesPerTeam: Scalars['Int'],
};

export type StockConfigInput = {
  teamStartingStockPrice: Scalars['Float'],
  initialOfferingNumShares: Scalars['Int'],
  totalSellableSharesPerTeam: Scalars['Int'],
};

export type StockPriceFormulaConfig = {
   __typename?: 'StockPriceFormulaConfig',
  netIncomeFactor: Scalars['Float'],
  totalAssetsFactor: Scalars['Float'],
  changeInIncomeFactor: Scalars['Float'],
  niRankFactor: Scalars['Float'],
};

export type StockPriceFormulaConfigInput = {
  netIncomeFactor: Scalars['Float'],
  totalAssetsFactor: Scalars['Float'],
  changeInIncomeFactor: Scalars['Float'],
  niRankFactor: Scalars['Float'],
};

export type StockSaleElection = {
   __typename?: 'StockSaleElection',
  quantityOffered: Scalars['Int'],
  stockPrice: Scalars['Float'],
};

export type StockSaleElectionInput = {
  quantityOffered: Scalars['Int'],
  stockPrice: Scalars['Float'],
};

export type StockTickerDataPoint = {
   __typename?: 'StockTickerDataPoint',
  team: Team,
  roundConfigId: Scalars['ID'],
  roundIndex: Scalars['Int'],
  stockPrice: Scalars['Float'],
  changeFromPreviousRound?: Maybe<Scalars['Float']>,
};

export type StoreFurnishingAsset = {
   __typename?: 'StoreFurnishingAsset',
  id?: Maybe<Scalars['ID']>,
  team?: Maybe<Team>,
  name?: Maybe<Scalars['String']>,
  furnishingConfigId?: Maybe<Scalars['ID']>,
  purchaseElectionId?: Maybe<Scalars['ID']>,
  saleElectionId?: Maybe<Scalars['ID']>,
  totalCapacity?: Maybe<Scalars['Int']>,
  usefulLife?: Maybe<Scalars['Int']>,
  remainingUsefulLife?: Maybe<Scalars['Int']>,
  roundPurchasedIndex?: Maybe<Scalars['Int']>,
  originalPurchasePrice?: Maybe<Scalars['Float']>,
  salePrice?: Maybe<Scalars['Float']>,
  isSellable?: Maybe<Scalars['Boolean']>,
  isSold?: Maybe<Scalars['Boolean']>,
  depreciationMethod?: Maybe<Scalars['String']>,
  annualDepreciationPercent?: Maybe<Scalars['Float']>,
  depreciationExpense?: Maybe<Scalars['Float']>,
  a_d?: Maybe<Scalars['Float']>,
  expiringRoundId?: Maybe<Scalars['ID']>,
  friendlyId: Scalars['String'],
  originalRoundPurchasedNum?: Maybe<Scalars['Int']>,
};

export type StoreFurnishingAssetInput = {
  name: Scalars['String'],
  building: Scalars['String'],
  totalCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  originalPurchasePrice: Scalars['Float'],
  depreciationMethod?: Maybe<Scalars['String']>,
};

export type StoreFurnishingConfig = {
   __typename?: 'StoreFurnishingConfig',
  id?: Maybe<Scalars['ID']>,
  typesConfig?: Maybe<Array<Maybe<StoreFurnishingTypeDynamicConfig>>>,
};

export type StoreFurnishingConfigInput = {
  id?: Maybe<Scalars['ID']>,
  typesConfig: Array<Maybe<StoreFurnishingTypeDynamicConfigInput>>,
};

export type StoreFurnishingPurchaseElection = {
   __typename?: 'StoreFurnishingPurchaseElection',
  furnishingConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  type: Scalars['String'],
  depreciationMethod: Scalars['String'],
  capacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
};

export type StoreFurnishingPurchaseElectionInput = {
  furnishingConfigId: Scalars['ID'],
  purchasePrice: Scalars['Float'],
  type: Scalars['String'],
  depreciationMethod: Scalars['String'],
  capacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
};

export type StoreFurnishingSaleElection = {
   __typename?: 'StoreFurnishingSaleElection',
  furnishingAssetId?: Maybe<Scalars['ID']>,
  furnishingConfigId?: Maybe<Scalars['ID']>,
  salePrice?: Maybe<Scalars['Float']>,
  originalPurchasePrice?: Maybe<Scalars['Float']>,
};

export type StoreFurnishingSaleElectionInput = {
  furnishingAssetId?: Maybe<Scalars['ID']>,
  furnishingConfigId?: Maybe<Scalars['ID']>,
  salePrice: Scalars['Float'],
  originalPurchasePrice: Scalars['Float'],
};

export type StoreFurnishingTypeDynamicConfig = {
   __typename?: 'StoreFurnishingTypeDynamicConfig',
  miniId: Scalars['String'],
  furnishingType: Scalars['String'],
  purchaseCost: Scalars['Float'],
  productionCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  depreciationMethods: Array<Maybe<Scalars['String']>>,
  defaultDepreciationMethod: Scalars['String'],
};

export type StoreFurnishingTypeDynamicConfigInput = {
  furnishingType: Scalars['String'],
  purchaseCost: Scalars['Float'],
  productionCapacity: Scalars['Int'],
  usefulLife: Scalars['Int'],
  depreciationMethods: Array<Maybe<Scalars['String']>>,
  defaultDepreciationMethod: Scalars['String'],
};

export type StudentInput = {
  id?: Maybe<Scalars['ID']>,
  email: Scalars['String'],
  firstname: Scalars['String'],
  lastname: Scalars['String'],
};

export type StudentOnboardInput = {
  student: StudentInput,
  teamId: Scalars['ID'],
  stripeToken?: Maybe<Scalars['String']>,
  licenseKey?: Maybe<Scalars['String']>,
  cognitoId?: Maybe<Scalars['String']>,
};

export enum SystemStatusEnum {
  Ready = 'READY',
  NotReady = 'NOT_READY'
}

export type SystemStatusResponse = {
   __typename?: 'SystemStatusResponse',
  text?: Maybe<SystemStatusEnum>,
};

export type TAccount = {
   __typename?: 'TAccount',
  account?: Maybe<Account>,
  friendlyName?: Maybe<Scalars['String']>,
  normalBalance?: Maybe<NormalBalance>,
  type?: Maybe<TAccountType>,
  beginningBalance?: Maybe<Scalars['Float']>,
  endingBalance?: Maybe<Scalars['Float']>,
  roundConfigId?: Maybe<Scalars['ID']>,
  team?: Maybe<Team>,
  entries?: Maybe<Array<Maybe<GeneralLedgerEntry>>>,
};

export enum TAccountType {
  Permanent = 'PERMANENT',
  Temporary = 'TEMPORARY'
}

export type Team = {
   __typename?: 'Team',
  id: Scalars['ID'],
  semester?: Maybe<Semester>,
  name?: Maybe<Scalars['String']>,
  students?: Maybe<Array<Maybe<User>>>,
  colorCode?: Maybe<Scalars['String']>,
  stockSymbol: Scalars['String'],
};

export type TeamColor = {
   __typename?: 'TeamColor',
  name: Scalars['String'],
  hexCode: Scalars['String'],
};

export type TeamStockResponse = {
   __typename?: 'TeamStockResponse',
  roundConfigId: Scalars['ID'],
  stockPrice: Scalars['Float'],
};


export type User = {
   __typename?: 'User',
  id: Scalars['ID'],
  userName: Scalars['String'],
  email: Scalars['String'],
  loginCode?: Maybe<Scalars['String']>,
  firstname: Scalars['String'],
  lastname: Scalars['String'],
  canBeProfessor: Scalars['Boolean'],
  settings?: Maybe<UserSettings>,
};

export type UserLicenseStatus = {
   __typename?: 'UserLicenseStatus',
  email: Scalars['String'],
  currentLicense?: Maybe<License>,
  licenseStatus: LicenseStatusEnum,
  pendingLicense?: Maybe<License>,
  warningNote?: Maybe<Scalars['String']>,
  durationOfWarning?: Maybe<Scalars['Float']>,
};

export type UserSettings = {
   __typename?: 'UserSettings',
  emailPreference?: Maybe<EmailPreference>,
};

export type UserSettingsInput = {
  emailPreference?: Maybe<EmailPreference>,
};

export enum UserTypeEnum {
  Admin = 'ADMIN',
  Professor = 'PROFESSOR',
  Student = 'STUDENT'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;


export type StitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes>;

export type isTypeOfResolverFn = (obj: any, info: GraphQLResolveInfo) => boolean;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>,
  ID: ResolverTypeWrapper<Scalars['ID']>,
  Course: ResolverTypeWrapper<Course>,
  String: ResolverTypeWrapper<Scalars['String']>,
  Int: ResolverTypeWrapper<Scalars['Int']>,
  User: ResolverTypeWrapper<User>,
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>,
  UserSettings: ResolverTypeWrapper<UserSettings>,
  EmailPreference: EmailPreference,
  GameProduct: ResolverTypeWrapper<GameProduct>,
  RoundConfig: ResolverTypeWrapper<RoundConfig>,
  Float: ResolverTypeWrapper<Scalars['Float']>,
  BuildingConfig: ResolverTypeWrapper<BuildingConfig>,
  BuildingTypeDynamicConfig: ResolverTypeWrapper<BuildingTypeDynamicConfig>,
  EquipmentConfig: ResolverTypeWrapper<EquipmentConfig>,
  EquipmentTypeDynamicConfig: ResolverTypeWrapper<EquipmentTypeDynamicConfig>,
  LandConfig: ResolverTypeWrapper<LandConfig>,
  StoreFurnishingConfig: ResolverTypeWrapper<StoreFurnishingConfig>,
  StoreFurnishingTypeDynamicConfig: ResolverTypeWrapper<StoreFurnishingTypeDynamicConfig>,
  DebtConfig: ResolverTypeWrapper<DebtConfig>,
  ProductConfig: ResolverTypeWrapper<ProductConfig>,
  BondsConfig: ResolverTypeWrapper<BondsConfig>,
  BondOptions: ResolverTypeWrapper<BondOptions>,
  GameConfig: ResolverTypeWrapper<GameConfig>,
  PreloadAssets: ResolverTypeWrapper<PreloadAssets>,
  PreloadLandAsset: ResolverTypeWrapper<PreloadLandAsset>,
  PreloadBuildingAsset: ResolverTypeWrapper<PreloadBuildingAsset>,
  PreloadEquipmentAsset: ResolverTypeWrapper<PreloadEquipmentAsset>,
  PreloadStoreFurnishingAsset: ResolverTypeWrapper<PreloadStoreFurnishingAsset>,
  PreloadDebtLiability: ResolverTypeWrapper<PreloadDebtLiability>,
  PreloadInventory: ResolverTypeWrapper<PreloadInventory>,
  GameConfigRoundFeatures: ResolverTypeWrapper<GameConfigRoundFeatures>,
  AdvertisingFeature: ResolverTypeWrapper<AdvertisingFeature>,
  BorrowingCapsFeature: ResolverTypeWrapper<BorrowingCapsFeature>,
  CashFlowConfig: ResolverTypeWrapper<CashFlowConfig>,
  RoundModuleDisplaySettingEnum: RoundModuleDisplaySettingEnum,
  CashFlowDisabledFieldsEnum: CashFlowDisabledFieldsEnum,
  IncomeStatementConfig: ResolverTypeWrapper<IncomeStatementConfig>,
  IncomeStatementDisabledFieldsEnum: IncomeStatementDisabledFieldsEnum,
  BalanceSheetConfig: ResolverTypeWrapper<BalanceSheetConfig>,
  BalanceSheetDisabledFieldsEnum: BalanceSheetDisabledFieldsEnum,
  StockPriceFormulaConfig: ResolverTypeWrapper<StockPriceFormulaConfig>,
  ARRoundFeature: ResolverTypeWrapper<ArRoundFeature>,
  JunkLoanConfig: ResolverTypeWrapper<JunkLoanConfig>,
  StockConfig: ResolverTypeWrapper<StockConfig>,
  CurrentAssets: ResolverTypeWrapper<CurrentAssets>,
  LandAsset: ResolverTypeWrapper<LandAsset>,
  Team: ResolverTypeWrapper<Team>,
  Semester: ResolverTypeWrapper<Semester>,
  SemesterSeason: SemesterSeason,
  RoundTiming: ResolverTypeWrapper<RoundTiming>,
  TeamColor: ResolverTypeWrapper<TeamColor>,
  RoundSalesReturn: ResolverTypeWrapper<RoundSalesReturn>,
  GameRoundPhase: GameRoundPhase,
  BuildingAsset: ResolverTypeWrapper<BuildingAsset>,
  EquipmentAsset: ResolverTypeWrapper<EquipmentAsset>,
  StoreFurnishingAsset: ResolverTypeWrapper<StoreFurnishingAsset>,
  DebtLiability: ResolverTypeWrapper<DebtLiability>,
  DebtRepayment: ResolverTypeWrapper<DebtRepayment>,
  ProductInventoryReport: ResolverTypeWrapper<ProductInventoryReport>,
  StockSaleElection: ResolverTypeWrapper<StockSaleElection>,
  BondAsset: ResolverTypeWrapper<BondAsset>,
  RoundElection: ResolverTypeWrapper<RoundElection>,
  BuildingPurchaseElection: ResolverTypeWrapper<BuildingPurchaseElection>,
  BuildingSaleElection: ResolverTypeWrapper<BuildingSaleElection>,
  EquipmentPurchaseElection: ResolverTypeWrapper<EquipmentPurchaseElection>,
  EquipmentSaleElection: ResolverTypeWrapper<EquipmentSaleElection>,
  LandPurchaseElection: ResolverTypeWrapper<LandPurchaseElection>,
  LandSaleElection: ResolverTypeWrapper<LandSaleElection>,
  StoreFurnishingPurchaseElection: ResolverTypeWrapper<StoreFurnishingPurchaseElection>,
  StoreFurnishingSaleElection: ResolverTypeWrapper<StoreFurnishingSaleElection>,
  DebtBorrowElection: ResolverTypeWrapper<DebtBorrowElection>,
  DebtRepaymentElection: ResolverTypeWrapper<DebtRepaymentElection>,
  ProductElection: ResolverTypeWrapper<ProductElection>,
  BondSaleElection: ResolverTypeWrapper<BondSaleElection>,
  License: ResolverTypeWrapper<License>,
  UserTypeEnum: UserTypeEnum,
  UserLicenseStatus: ResolverTypeWrapper<UserLicenseStatus>,
  LicenseStatusEnum: LicenseStatusEnum,
  GameState: ResolverTypeWrapper<GameState>,
  MarketCalc: ResolverTypeWrapper<MarketCalc>,
  IncomeStatement: ResolverTypeWrapper<IncomeStatement>,
  FieldAnswer: ResolverTypeWrapper<FieldAnswer>,
  BalanceSheet: ResolverTypeWrapper<BalanceSheet>,
  CashFlow: ResolverTypeWrapper<CashFlow>,
  SalesReportEntry: ResolverTypeWrapper<SalesReportEntry>,
  GradingReport: ResolverTypeWrapper<GradingReport>,
  RoundInventoryCosts: ResolverTypeWrapper<RoundInventoryCosts>,
  RemainingInventoryCosts: ResolverTypeWrapper<RemainingInventoryCosts>,
  ScoreboardData: ResolverTypeWrapper<ScoreboardData>,
  ScoreboardRound: ResolverTypeWrapper<ScoreboardRound>,
  ScoreboardTeamDataPoint: ResolverTypeWrapper<ScoreboardTeamDataPoint>,
  SystemStatusResponse: ResolverTypeWrapper<SystemStatusResponse>,
  SystemStatusEnum: SystemStatusEnum,
  SimulationData: ResolverTypeWrapper<SimulationData>,
  SimulationTeam: ResolverTypeWrapper<SimulationTeam>,
  SimulationSheet: ResolverTypeWrapper<SimulationSheet>,
  GameResults: ResolverTypeWrapper<GameResults>,
  ResultingGL: ResolverTypeWrapper<ResultingGl>,
  Account: Account,
  ResultingIS: ResolverTypeWrapper<ResultingIs>,
  ResultingBS: ResolverTypeWrapper<ResultingBs>,
  ResultingCF: ResolverTypeWrapper<ResultingCf>,
  ResultingLand: ResolverTypeWrapper<ResultingLand>,
  ResultingBuilding: ResolverTypeWrapper<ResultingBuilding>,
  ResultingDepreciationChange: ResolverTypeWrapper<ResultingDepreciationChange>,
  ResultingEquipment: ResolverTypeWrapper<ResultingEquipment>,
  ResultingDebt: ResolverTypeWrapper<ResultingDebt>,
  ResultingDebtRepayment: ResolverTypeWrapper<ResultingDebtRepayment>,
  ResultingInventory: ResolverTypeWrapper<ResultingInventory>,
  ResultingInventoryChange: ResolverTypeWrapper<ResultingInventoryChange>,
  ResultingSalesReport: ResolverTypeWrapper<ResultingSalesReport>,
  GeneralLedgerTableEntry: ResolverTypeWrapper<GeneralLedgerTableEntry>,
  JournalEntriesAndTAccountsResponse: ResolverTypeWrapper<JournalEntriesAndTAccountsResponse>,
  JournalEntry: ResolverTypeWrapper<JournalEntry>,
  GeneralLedgerEntry: ResolverTypeWrapper<GeneralLedgerEntry>,
  JournalEntryTypeEnum: JournalEntryTypeEnum,
  NormalBalance: NormalBalance,
  TAccount: ResolverTypeWrapper<TAccount>,
  TAccountType: TAccountType,
  StockTickerDataPoint: ResolverTypeWrapper<StockTickerDataPoint>,
  TeamStockResponse: ResolverTypeWrapper<TeamStockResponse>,
  FinancialRatio: ResolverTypeWrapper<FinancialRatio>,
  RoundTimingInput: RoundTimingInput,
  Message: ResolverTypeWrapper<Message>,
  MessageTypeEnum: MessageTypeEnum,
  MessagePriorityEnum: MessagePriorityEnum,
  CustomLabel: ResolverTypeWrapper<CustomLabel>,
  CustomLabelGroup: CustomLabelGroup,
  CourseTemplate: ResolverTypeWrapper<CourseTemplate>,
  Mutation: ResolverTypeWrapper<{}>,
  CheckGameFlowsResult: ResolverTypeWrapper<CheckGameFlowsResult>,
  GameRoundTuple: ResolverTypeWrapper<GameRoundTuple>,
  CourseInput: CourseInput,
  RoundConfigInput: RoundConfigInput,
  BuildingConfigInput: BuildingConfigInput,
  BuildingTypeDynamicConfigInput: BuildingTypeDynamicConfigInput,
  EquipmentConfigInput: EquipmentConfigInput,
  EquipmentTypeDynamicConfigInput: EquipmentTypeDynamicConfigInput,
  LandConfigInput: LandConfigInput,
  StoreFurnishingConfigInput: StoreFurnishingConfigInput,
  StoreFurnishingTypeDynamicConfigInput: StoreFurnishingTypeDynamicConfigInput,
  DebtConfigInput: DebtConfigInput,
  ProductConfigInput: ProductConfigInput,
  BondsConfigInput: BondsConfigInput,
  BondOptionsInput: BondOptionsInput,
  GameConfigInput: GameConfigInput,
  PreloadAssetsInput: PreloadAssetsInput,
  LandAssetInput: LandAssetInput,
  BuildingAssetInput: BuildingAssetInput,
  EquipmentAssetInput: EquipmentAssetInput,
  StoreFurnishingAssetInput: StoreFurnishingAssetInput,
  DebtLiabilityInput: DebtLiabilityInput,
  ProductInventoryInput: ProductInventoryInput,
  GameConfigRoundFeaturesInput: GameConfigRoundFeaturesInput,
  AdvertisingFeatureInput: AdvertisingFeatureInput,
  BorrowingCapsFeatureInput: BorrowingCapsFeatureInput,
  CashFlowConfigInput: CashFlowConfigInput,
  IncomeStatementConfigInput: IncomeStatementConfigInput,
  BalanceSheetConfigInput: BalanceSheetConfigInput,
  StockPriceFormulaConfigInput: StockPriceFormulaConfigInput,
  ARRoundFeatureInput: ArRoundFeatureInput,
  JunkLoanConfigInput: JunkLoanConfigInput,
  StockConfigInput: StockConfigInput,
  CourseTemplateInput: CourseTemplateInput,
  CourseTemplateGameConfigInput: CourseTemplateGameConfigInput,
  LicenseInput: LicenseInput,
  SemesterInput: SemesterInput,
  RoundElectionInput: RoundElectionInput,
  BuildingPurchaseElectionInput: BuildingPurchaseElectionInput,
  BuildingSaleElectionInput: BuildingSaleElectionInput,
  EquipmentPurchaseElectionInput: EquipmentPurchaseElectionInput,
  EquipmentSaleElectionInput: EquipmentSaleElectionInput,
  LandPurchaseElectionInput: LandPurchaseElectionInput,
  LandSaleElectionInput: LandSaleElectionInput,
  StoreFurnishingPurchaseElectionInput: StoreFurnishingPurchaseElectionInput,
  StoreFurnishingSaleElectionInput: StoreFurnishingSaleElectionInput,
  DebtBorrowElectionInput: DebtBorrowElectionInput,
  DebtRepaymentElectionInput: DebtRepaymentElectionInput,
  ProductElectionInput: ProductElectionInput,
  StockSaleElectionInput: StockSaleElectionInput,
  BondSaleElectionInput: BondSaleElectionInput,
  IncomeStatementInput: IncomeStatementInput,
  BalanceSheetInput: BalanceSheetInput,
  CashFlowInput: CashFlowInput,
  RemovePlayerResponse: ResolverTypeWrapper<RemovePlayerResponse>,
  SimulationInput: SimulationInput,
  Error: ResolverTypeWrapper<Error>,
  SendMessageInput: SendMessageInput,
  LastNotificationCheck: ResolverTypeWrapper<LastNotificationCheck>,
  UserSettingsInput: UserSettingsInput,
  AssetType: AssetType,
  BondLiability: ResolverTypeWrapper<BondLiability>,
  CacheControlScope: CacheControlScope,
  GameProductInput: GameProductInput,
  InventoryChange: ResolverTypeWrapper<InventoryChange>,
  ProductInventory: ResolverTypeWrapper<ProductInventory>,
  ProfessorInput: ProfessorInput,
  ResultingStoreFurnishing: ResolverTypeWrapper<ResultingStoreFurnishing>,
  SimulationDataInput: SimulationDataInput,
  SimulationTeamInput: SimulationTeamInput,
  SimulationSheetInput: SimulationSheetInput,
  StudentInput: StudentInput,
  StudentOnboardInput: StudentOnboardInput,
  Upload: ResolverTypeWrapper<Scalars['Upload']>,
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {},
  ID: Scalars['ID'],
  Course: Course,
  String: Scalars['String'],
  Int: Scalars['Int'],
  User: User,
  Boolean: Scalars['Boolean'],
  UserSettings: UserSettings,
  EmailPreference: EmailPreference,
  GameProduct: GameProduct,
  RoundConfig: RoundConfig,
  Float: Scalars['Float'],
  BuildingConfig: BuildingConfig,
  BuildingTypeDynamicConfig: BuildingTypeDynamicConfig,
  EquipmentConfig: EquipmentConfig,
  EquipmentTypeDynamicConfig: EquipmentTypeDynamicConfig,
  LandConfig: LandConfig,
  StoreFurnishingConfig: StoreFurnishingConfig,
  StoreFurnishingTypeDynamicConfig: StoreFurnishingTypeDynamicConfig,
  DebtConfig: DebtConfig,
  ProductConfig: ProductConfig,
  BondsConfig: BondsConfig,
  BondOptions: BondOptions,
  GameConfig: GameConfig,
  PreloadAssets: PreloadAssets,
  PreloadLandAsset: PreloadLandAsset,
  PreloadBuildingAsset: PreloadBuildingAsset,
  PreloadEquipmentAsset: PreloadEquipmentAsset,
  PreloadStoreFurnishingAsset: PreloadStoreFurnishingAsset,
  PreloadDebtLiability: PreloadDebtLiability,
  PreloadInventory: PreloadInventory,
  GameConfigRoundFeatures: GameConfigRoundFeatures,
  AdvertisingFeature: AdvertisingFeature,
  BorrowingCapsFeature: BorrowingCapsFeature,
  CashFlowConfig: CashFlowConfig,
  RoundModuleDisplaySettingEnum: RoundModuleDisplaySettingEnum,
  CashFlowDisabledFieldsEnum: CashFlowDisabledFieldsEnum,
  IncomeStatementConfig: IncomeStatementConfig,
  IncomeStatementDisabledFieldsEnum: IncomeStatementDisabledFieldsEnum,
  BalanceSheetConfig: BalanceSheetConfig,
  BalanceSheetDisabledFieldsEnum: BalanceSheetDisabledFieldsEnum,
  StockPriceFormulaConfig: StockPriceFormulaConfig,
  ARRoundFeature: ArRoundFeature,
  JunkLoanConfig: JunkLoanConfig,
  StockConfig: StockConfig,
  CurrentAssets: CurrentAssets,
  LandAsset: LandAsset,
  Team: Team,
  Semester: Semester,
  SemesterSeason: SemesterSeason,
  RoundTiming: RoundTiming,
  TeamColor: TeamColor,
  RoundSalesReturn: RoundSalesReturn,
  GameRoundPhase: GameRoundPhase,
  BuildingAsset: BuildingAsset,
  EquipmentAsset: EquipmentAsset,
  StoreFurnishingAsset: StoreFurnishingAsset,
  DebtLiability: DebtLiability,
  DebtRepayment: DebtRepayment,
  ProductInventoryReport: ProductInventoryReport,
  StockSaleElection: StockSaleElection,
  BondAsset: BondAsset,
  RoundElection: RoundElection,
  BuildingPurchaseElection: BuildingPurchaseElection,
  BuildingSaleElection: BuildingSaleElection,
  EquipmentPurchaseElection: EquipmentPurchaseElection,
  EquipmentSaleElection: EquipmentSaleElection,
  LandPurchaseElection: LandPurchaseElection,
  LandSaleElection: LandSaleElection,
  StoreFurnishingPurchaseElection: StoreFurnishingPurchaseElection,
  StoreFurnishingSaleElection: StoreFurnishingSaleElection,
  DebtBorrowElection: DebtBorrowElection,
  DebtRepaymentElection: DebtRepaymentElection,
  ProductElection: ProductElection,
  BondSaleElection: BondSaleElection,
  License: License,
  UserTypeEnum: UserTypeEnum,
  UserLicenseStatus: UserLicenseStatus,
  LicenseStatusEnum: LicenseStatusEnum,
  GameState: GameState,
  MarketCalc: MarketCalc,
  IncomeStatement: IncomeStatement,
  FieldAnswer: FieldAnswer,
  BalanceSheet: BalanceSheet,
  CashFlow: CashFlow,
  SalesReportEntry: SalesReportEntry,
  GradingReport: GradingReport,
  RoundInventoryCosts: RoundInventoryCosts,
  RemainingInventoryCosts: RemainingInventoryCosts,
  ScoreboardData: ScoreboardData,
  ScoreboardRound: ScoreboardRound,
  ScoreboardTeamDataPoint: ScoreboardTeamDataPoint,
  SystemStatusResponse: SystemStatusResponse,
  SystemStatusEnum: SystemStatusEnum,
  SimulationData: SimulationData,
  SimulationTeam: SimulationTeam,
  SimulationSheet: SimulationSheet,
  GameResults: GameResults,
  ResultingGL: ResultingGl,
  Account: Account,
  ResultingIS: ResultingIs,
  ResultingBS: ResultingBs,
  ResultingCF: ResultingCf,
  ResultingLand: ResultingLand,
  ResultingBuilding: ResultingBuilding,
  ResultingDepreciationChange: ResultingDepreciationChange,
  ResultingEquipment: ResultingEquipment,
  ResultingDebt: ResultingDebt,
  ResultingDebtRepayment: ResultingDebtRepayment,
  ResultingInventory: ResultingInventory,
  ResultingInventoryChange: ResultingInventoryChange,
  ResultingSalesReport: ResultingSalesReport,
  GeneralLedgerTableEntry: GeneralLedgerTableEntry,
  JournalEntriesAndTAccountsResponse: JournalEntriesAndTAccountsResponse,
  JournalEntry: JournalEntry,
  GeneralLedgerEntry: GeneralLedgerEntry,
  JournalEntryTypeEnum: JournalEntryTypeEnum,
  NormalBalance: NormalBalance,
  TAccount: TAccount,
  TAccountType: TAccountType,
  StockTickerDataPoint: StockTickerDataPoint,
  TeamStockResponse: TeamStockResponse,
  FinancialRatio: FinancialRatio,
  RoundTimingInput: RoundTimingInput,
  Message: Message,
  MessageTypeEnum: MessageTypeEnum,
  MessagePriorityEnum: MessagePriorityEnum,
  CustomLabel: CustomLabel,
  CustomLabelGroup: CustomLabelGroup,
  CourseTemplate: CourseTemplate,
  Mutation: {},
  CheckGameFlowsResult: CheckGameFlowsResult,
  GameRoundTuple: GameRoundTuple,
  CourseInput: CourseInput,
  RoundConfigInput: RoundConfigInput,
  BuildingConfigInput: BuildingConfigInput,
  BuildingTypeDynamicConfigInput: BuildingTypeDynamicConfigInput,
  EquipmentConfigInput: EquipmentConfigInput,
  EquipmentTypeDynamicConfigInput: EquipmentTypeDynamicConfigInput,
  LandConfigInput: LandConfigInput,
  StoreFurnishingConfigInput: StoreFurnishingConfigInput,
  StoreFurnishingTypeDynamicConfigInput: StoreFurnishingTypeDynamicConfigInput,
  DebtConfigInput: DebtConfigInput,
  ProductConfigInput: ProductConfigInput,
  BondsConfigInput: BondsConfigInput,
  BondOptionsInput: BondOptionsInput,
  GameConfigInput: GameConfigInput,
  PreloadAssetsInput: PreloadAssetsInput,
  LandAssetInput: LandAssetInput,
  BuildingAssetInput: BuildingAssetInput,
  EquipmentAssetInput: EquipmentAssetInput,
  StoreFurnishingAssetInput: StoreFurnishingAssetInput,
  DebtLiabilityInput: DebtLiabilityInput,
  ProductInventoryInput: ProductInventoryInput,
  GameConfigRoundFeaturesInput: GameConfigRoundFeaturesInput,
  AdvertisingFeatureInput: AdvertisingFeatureInput,
  BorrowingCapsFeatureInput: BorrowingCapsFeatureInput,
  CashFlowConfigInput: CashFlowConfigInput,
  IncomeStatementConfigInput: IncomeStatementConfigInput,
  BalanceSheetConfigInput: BalanceSheetConfigInput,
  StockPriceFormulaConfigInput: StockPriceFormulaConfigInput,
  ARRoundFeatureInput: ArRoundFeatureInput,
  JunkLoanConfigInput: JunkLoanConfigInput,
  StockConfigInput: StockConfigInput,
  CourseTemplateInput: CourseTemplateInput,
  CourseTemplateGameConfigInput: CourseTemplateGameConfigInput,
  LicenseInput: LicenseInput,
  SemesterInput: SemesterInput,
  RoundElectionInput: RoundElectionInput,
  BuildingPurchaseElectionInput: BuildingPurchaseElectionInput,
  BuildingSaleElectionInput: BuildingSaleElectionInput,
  EquipmentPurchaseElectionInput: EquipmentPurchaseElectionInput,
  EquipmentSaleElectionInput: EquipmentSaleElectionInput,
  LandPurchaseElectionInput: LandPurchaseElectionInput,
  LandSaleElectionInput: LandSaleElectionInput,
  StoreFurnishingPurchaseElectionInput: StoreFurnishingPurchaseElectionInput,
  StoreFurnishingSaleElectionInput: StoreFurnishingSaleElectionInput,
  DebtBorrowElectionInput: DebtBorrowElectionInput,
  DebtRepaymentElectionInput: DebtRepaymentElectionInput,
  ProductElectionInput: ProductElectionInput,
  StockSaleElectionInput: StockSaleElectionInput,
  BondSaleElectionInput: BondSaleElectionInput,
  IncomeStatementInput: IncomeStatementInput,
  BalanceSheetInput: BalanceSheetInput,
  CashFlowInput: CashFlowInput,
  RemovePlayerResponse: RemovePlayerResponse,
  SimulationInput: SimulationInput,
  Error: Error,
  SendMessageInput: SendMessageInput,
  LastNotificationCheck: LastNotificationCheck,
  UserSettingsInput: UserSettingsInput,
  AssetType: AssetType,
  BondLiability: BondLiability,
  CacheControlScope: CacheControlScope,
  GameProductInput: GameProductInput,
  InventoryChange: InventoryChange,
  ProductInventory: ProductInventory,
  ProfessorInput: ProfessorInput,
  ResultingStoreFurnishing: ResultingStoreFurnishing,
  SimulationDataInput: SimulationDataInput,
  SimulationTeamInput: SimulationTeamInput,
  SimulationSheetInput: SimulationSheetInput,
  StudentInput: StudentInput,
  StudentOnboardInput: StudentOnboardInput,
  Upload: Scalars['Upload'],
};

export type CacheControlDirectiveResolver<Result, Parent, ContextType = any, Args = {   maxAge?: Maybe<Scalars['Int']>,
  scope?: Maybe<CacheControlScope> }> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AdvertisingFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertisingFeature'] = ResolversParentTypes['AdvertisingFeature']> = {
  cost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  benefit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ArRoundFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['ARRoundFeature'] = ResolversParentTypes['ARRoundFeature']> = {
  outstandingPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  badDebtPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BalanceSheetResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceSheet'] = ResolversParentTypes['BalanceSheet']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  cash?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  inventory?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  equipment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  equipmentDepreciation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  buildings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  buildingsDepreciation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  furnishings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  furnishingsDepreciation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  land?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  totalAssets?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  loanPayable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  totalLiabilities?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  commonStock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  retainedEarnings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  totalLiabilitiesAndEquity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  bondsPayable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  bondsPremiumOrDiscount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  submittedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  incorrectAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldAnswer']>>>, ParentType, ContextType>,
  disabledFieldAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldAnswer']>>>, ParentType, ContextType>,
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BalanceSheetConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceSheetConfig'] = ResolversParentTypes['BalanceSheetConfig']> = {
  roundSetting?: Resolver<ResolversTypes['RoundModuleDisplaySettingEnum'], ParentType, ContextType>,
  disabledFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['BalanceSheetDisabledFieldsEnum']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BondAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['BondAsset'] = ResolversParentTypes['BondAsset']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  nominalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  friendlyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  quantityIssued?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  roundIssued?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  yearsRemaining?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  nominalInterestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  marketRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  unamortizedPremiumOrDiscount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BondLiabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BondLiability'] = ResolversParentTypes['BondLiability']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  team?: Resolver<ResolversTypes['Team'], ParentType, ContextType>,
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  term?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  roundBorrowedIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  realRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  nominalRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  bondElectionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  bondConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  pvInterest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  pvPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  originalPremiumOrDiscount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  unamortizedPremiumOrDiscount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  cumulativeAmortizationChanges?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  maturationRoundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  quantityIssued?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  friendlyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BondOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BondOptions'] = ResolversParentTypes['BondOptions']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  miniId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  nominalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  nominalInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  paymentDueQuarterEnd?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  numPaymentsPerYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  term?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BondSaleElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BondSaleElection'] = ResolversParentTypes['BondSaleElection']> = {
  bondConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  numBondsSold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  nominalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BondsConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BondsConfig'] = ResolversParentTypes['BondsConfig']> = {
  realInterestRateFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  bondOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['BondOptions']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BorrowingCapsFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BorrowingCapsFeature'] = ResolversParentTypes['BorrowingCapsFeature']> = {
  debtRoundBorrowCap?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  bondRoundBorrowCap?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  totalPrincipalCap?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BuildingAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuildingAsset'] = ResolversParentTypes['BuildingAsset']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  buildingConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  purchaseElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  saleElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  totalCapacity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  usefulLife?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  remainingUsefulLife?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  originalPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  equipments?: Resolver<Maybe<Array<Maybe<ResolversTypes['EquipmentAsset']>>>, ParentType, ContextType>,
  isSellable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  isSold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  depreciationMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  annualDepreciationPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  a_d?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  expiringRoundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  friendlyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  originalRoundPurchasedNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BuildingConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuildingConfig'] = ResolversParentTypes['BuildingConfig']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  typesConfig?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuildingTypeDynamicConfig']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BuildingPurchaseElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuildingPurchaseElection'] = ResolversParentTypes['BuildingPurchaseElection']> = {
  buildingConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  purchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  depreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  capacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BuildingSaleElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuildingSaleElection'] = ResolversParentTypes['BuildingSaleElection']> = {
  buildingAssetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  buildingConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  originalPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type BuildingTypeDynamicConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuildingTypeDynamicConfig'] = ResolversParentTypes['BuildingTypeDynamicConfig']> = {
  miniId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  buildingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  purchaseCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  equipmentCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  depreciationMethods?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>,
  defaultDepreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type CashFlowResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashFlow'] = ResolversParentTypes['CashFlow']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  team?: Resolver<ResolversTypes['Team'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  operatingActivitiesSales?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesPurchasedInventory?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesPaidAdvertising?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesSalesReturns?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesIncomeTaxesPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesInterestPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesInflowEquipment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesInflowBuildings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesInflowLand?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesOutflowEquipment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesOutflowBuildings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesInflowFurnishings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesOutflowFurnishings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesOutflowLand?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesCapital?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  bondBorrowing?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesLoanBorrow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  bondRepayment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesLoanRepay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  netCash?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  beginningOfRound?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  endOfRound?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  submittedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  incorrectAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldAnswer']>>>, ParentType, ContextType>,
  disabledFieldAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldAnswer']>>>, ParentType, ContextType>,
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type CashFlowConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashFlowConfig'] = ResolversParentTypes['CashFlowConfig']> = {
  roundSetting?: Resolver<ResolversTypes['RoundModuleDisplaySettingEnum'], ParentType, ContextType>,
  disabledFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['CashFlowDisabledFieldsEnum']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type CheckGameFlowsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckGameFlowsResult'] = ResolversParentTypes['CheckGameFlowsResult']> = {
  marketCalcedSemesters?: Resolver<Array<Maybe<ResolversTypes['GameRoundTuple']>>, ParentType, ContextType>,
  gradedSemesters?: Resolver<Array<Maybe<ResolversTypes['GameRoundTuple']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type CourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Course'] = ResolversParentTypes['Course']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  minTeams?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  maxTeams?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  minStudentsPerTeam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  maxStudentsPerTeam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  gameProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['GameProduct']>>>, ParentType, ContextType>,
  rounds?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoundConfig']>>>, ParentType, ContextType>,
  defaultGameConfig?: Resolver<ResolversTypes['GameConfig'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type CourseTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseTemplate'] = ResolversParentTypes['CourseTemplate']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  minTeams?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  maxTeams?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  minStudentsPerTeam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  maxStudentsPerTeam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  gameProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>,
  rounds?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoundConfig']>>>, ParentType, ContextType>,
  defaultGameConfig?: Resolver<ResolversTypes['GameConfig'], ParentType, ContextType>,
  isLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  professor?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  isSystemTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type CurrentAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentAssets'] = ResolversParentTypes['CurrentAssets']> = {
  currentCashBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  lands?: Resolver<Maybe<Array<Maybe<ResolversTypes['LandAsset']>>>, ParentType, ContextType>,
  buildings?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuildingAsset']>>>, ParentType, ContextType>,
  equipments?: Resolver<Maybe<Array<Maybe<ResolversTypes['EquipmentAsset']>>>, ParentType, ContextType>,
  storeFurnishings?: Resolver<Maybe<Array<Maybe<ResolversTypes['StoreFurnishingAsset']>>>, ParentType, ContextType>,
  debts?: Resolver<Maybe<Array<Maybe<ResolversTypes['DebtLiability']>>>, ParentType, ContextType>,
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInventoryReport']>>>, ParentType, ContextType>,
  stocks?: Resolver<Maybe<Array<Maybe<ResolversTypes['StockSaleElection']>>>, ParentType, ContextType>,
  bonds?: Resolver<Maybe<Array<Maybe<ResolversTypes['BondAsset']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type CustomLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomLabel'] = ResolversParentTypes['CustomLabel']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  group?: Resolver<Maybe<ResolversTypes['CustomLabelGroup']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type DebtBorrowElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebtBorrowElection'] = ResolversParentTypes['DebtBorrowElection']> = {
  debtConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  term?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  borrowingAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  friendlyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type DebtConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebtConfig'] = ResolversParentTypes['DebtConfig']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  borrowingRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  borrowingTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  repaymentRoundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  miniId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type DebtLiabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebtLiability'] = ResolversParentTypes['DebtLiability']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  debtConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  borrowElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  originalRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  originalTerm?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  yearsIntoTerm?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  originalPrincipal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  outstandingPrincipal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  roundBorrowedIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  repayments?: Resolver<Maybe<Array<Maybe<ResolversTypes['DebtRepayment']>>>, ParentType, ContextType>,
  isSellable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  isPaidOff?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  repaymentRoundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  friendlyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  originalRoundBorrowedNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type DebtRepaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebtRepayment'] = ResolversParentTypes['DebtRepayment']> = {
  debtLiabilityId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  repaymentRoundId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  repaymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  timeStamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type DebtRepaymentElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebtRepaymentElection'] = ResolversParentTypes['DebtRepaymentElection']> = {
  debtLiabilityId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  debtConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  term?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  repaymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type EquipmentAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentAsset'] = ResolversParentTypes['EquipmentAsset']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  equipmentConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  purchaseElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  saleElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  totalCapacity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  usefulLife?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  remainingUsefulLife?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  originalPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  isSellable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  isSold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  depreciationMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  annualDepreciationPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  a_d?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  expiringRoundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  friendlyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  originalRoundPurchasedNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type EquipmentConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentConfig'] = ResolversParentTypes['EquipmentConfig']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  typesConfig?: Resolver<Maybe<Array<Maybe<ResolversTypes['EquipmentTypeDynamicConfig']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type EquipmentPurchaseElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentPurchaseElection'] = ResolversParentTypes['EquipmentPurchaseElection']> = {
  equipmentConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  purchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  depreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  capacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type EquipmentSaleElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentSaleElection'] = ResolversParentTypes['EquipmentSaleElection']> = {
  equipmentAssetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  equipmentConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  originalPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type EquipmentTypeDynamicConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentTypeDynamicConfig'] = ResolversParentTypes['EquipmentTypeDynamicConfig']> = {
  miniId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  equipmentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  purchaseCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  productionCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  depreciationMethods?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>,
  defaultDepreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Error'] = ResolversParentTypes['Error']> = {
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type FieldAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldAnswer'] = ResolversParentTypes['FieldAnswer']> = {
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  correctAnswer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type FinancialRatioResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialRatio'] = ResolversParentTypes['FinancialRatio']> = {
  team?: Resolver<ResolversTypes['Team'], ParentType, ContextType>,
  earningsPerShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  priceEarnings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  debtToEquity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  returnOnEquity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  returnOnAssets?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GameConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['GameConfig'] = ResolversParentTypes['GameConfig']> = {
  preloadAssets?: Resolver<ResolversTypes['PreloadAssets'], ParentType, ContextType>,
  roundFeatures?: Resolver<ResolversTypes['GameConfigRoundFeatures'], ParentType, ContextType>,
  junkLoans?: Resolver<ResolversTypes['JunkLoanConfig'], ParentType, ContextType>,
  stockConfig?: Resolver<ResolversTypes['StockConfig'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GameConfigRoundFeaturesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GameConfigRoundFeatures'] = ResolversParentTypes['GameConfigRoundFeatures']> = {
  advertising?: Resolver<Array<Maybe<ResolversTypes['AdvertisingFeature']>>, ParentType, ContextType>,
  salesReturns?: Resolver<Array<Maybe<ResolversTypes['Boolean']>>, ParentType, ContextType>,
  incomeTax?: Resolver<Array<Maybe<ResolversTypes['Float']>>, ParentType, ContextType>,
  borrowingCaps?: Resolver<Array<Maybe<ResolversTypes['BorrowingCapsFeature']>>, ParentType, ContextType>,
  cashFlowConfig?: Resolver<Array<Maybe<ResolversTypes['CashFlowConfig']>>, ParentType, ContextType>,
  incomeStatementConfig?: Resolver<Array<Maybe<ResolversTypes['IncomeStatementConfig']>>, ParentType, ContextType>,
  balanceSheetConfig?: Resolver<Array<Maybe<ResolversTypes['BalanceSheetConfig']>>, ParentType, ContextType>,
  journalEntryTAccountConfig?: Resolver<Array<Maybe<ResolversTypes['RoundModuleDisplaySettingEnum']>>, ParentType, ContextType>,
  requirePositiveCashBalanceBeforeElecting?: Resolver<Array<Maybe<ResolversTypes['Boolean']>>, ParentType, ContextType>,
  stockPriceConfig?: Resolver<Array<Maybe<ResolversTypes['StockPriceFormulaConfig']>>, ParentType, ContextType>,
  accountsReceivable?: Resolver<Array<Maybe<ResolversTypes['ARRoundFeature']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GameProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['GameProduct'] = ResolversParentTypes['GameProduct']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GameResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GameResults'] = ResolversParentTypes['GameResults']> = {
  generalLedger?: Resolver<Array<ResolversTypes['ResultingGL']>, ParentType, ContextType>,
  incomeStatements?: Resolver<Array<ResolversTypes['ResultingIS']>, ParentType, ContextType>,
  balanceSheets?: Resolver<Array<ResolversTypes['ResultingBS']>, ParentType, ContextType>,
  cashFlows?: Resolver<Array<ResolversTypes['ResultingCF']>, ParentType, ContextType>,
  landAssets?: Resolver<Array<ResolversTypes['ResultingLand']>, ParentType, ContextType>,
  buildingAssets?: Resolver<Array<ResolversTypes['ResultingBuilding']>, ParentType, ContextType>,
  equipmentAssets?: Resolver<Array<ResolversTypes['ResultingEquipment']>, ParentType, ContextType>,
  loans?: Resolver<Array<ResolversTypes['ResultingDebt']>, ParentType, ContextType>,
  inventory?: Resolver<Array<ResolversTypes['ResultingInventory']>, ParentType, ContextType>,
  salesReports?: Resolver<Array<ResolversTypes['ResultingSalesReport']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GameRoundTupleResolvers<ContextType = any, ParentType extends ResolversParentTypes['GameRoundTuple'] = ResolversParentTypes['GameRoundTuple']> = {
  semesterId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GameStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GameState'] = ResolversParentTypes['GameState']> = {
  roundIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  roundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  phase?: Resolver<ResolversTypes['GameRoundPhase'], ParentType, ContextType>,
  lastMarketCalc?: Resolver<Maybe<ResolversTypes['MarketCalc']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GeneralLedgerEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneralLedgerEntry'] = ResolversParentTypes['GeneralLedgerEntry']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  roundConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  roundIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>,
  journalEntryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  miniId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  journalEntryTypeEnum?: Resolver<Maybe<ResolversTypes['JournalEntryTypeEnum']>, ParentType, ContextType>,
  friendlyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  normalBalance?: Resolver<Maybe<ResolversTypes['NormalBalance']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GeneralLedgerTableEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneralLedgerTableEntry'] = ResolversParentTypes['GeneralLedgerTableEntry']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  roundNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  teamName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type GradingReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['GradingReport'] = ResolversParentTypes['GradingReport']> = {
  roundConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  teamId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  incomeStatementNumCorrect?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  incomeStatementTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  balanceSheetNumCorrect?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  balanceSheetTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  cashFlowNumCorrect?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  cashFlowTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  combinedNumCorrect?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  combinedTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type IncomeStatementResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncomeStatement'] = ResolversParentTypes['IncomeStatement']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  team?: Resolver<ResolversTypes['Team'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  revenue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  returns?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  net?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  costOfGoodsSold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  grossProfit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  adExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  interest?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  gainOnAssetSales?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  accountsReceivable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  badDebtExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  incomeTax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  netIncome?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  submittedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  incorrectAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldAnswer']>>>, ParentType, ContextType>,
  disabledFieldAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldAnswer']>>>, ParentType, ContextType>,
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type IncomeStatementConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncomeStatementConfig'] = ResolversParentTypes['IncomeStatementConfig']> = {
  roundSetting?: Resolver<ResolversTypes['RoundModuleDisplaySettingEnum'], ParentType, ContextType>,
  disabledFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['IncomeStatementDisabledFieldsEnum']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type InventoryChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryChange'] = ResolversParentTypes['InventoryChange']> = {
  productInventoryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  inventoryAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type JournalEntriesAndTAccountsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['JournalEntriesAndTAccountsResponse'] = ResolversParentTypes['JournalEntriesAndTAccountsResponse']> = {
  journalEntries?: Resolver<Maybe<Array<Maybe<ResolversTypes['JournalEntry']>>>, ParentType, ContextType>,
  tAccounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['TAccount']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type JournalEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['JournalEntry'] = ResolversParentTypes['JournalEntry']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  friendlyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  miniId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeneralLedgerEntry']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type JunkLoanConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['JunkLoanConfig'] = ResolversParentTypes['JunkLoanConfig']> = {
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  term?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type LandAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandAsset'] = ResolversParentTypes['LandAsset']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  landConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  purchaseElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  saleElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  totalCapacity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  originalPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  buildings?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuildingAsset']>>>, ParentType, ContextType>,
  isSellable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  isSold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  friendlyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  originalRoundPurchasedNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type LandConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandConfig'] = ResolversParentTypes['LandConfig']> = {
  miniId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  purchaseCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  buildingCapacity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type LandPurchaseElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandPurchaseElection'] = ResolversParentTypes['LandPurchaseElection']> = {
  landConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  purchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  capacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type LandSaleElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandSaleElection'] = ResolversParentTypes['LandSaleElection']> = {
  landAssetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  landConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  salePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type LastNotificationCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastNotificationCheck'] = ResolversParentTypes['LastNotificationCheck']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  teamId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  lastCheckedTimestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type LicenseResolvers<ContextType = any, ParentType extends ResolversParentTypes['License'] = ResolversParentTypes['License']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  revokedTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  isBanned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  purchaseNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  licenseType?: Resolver<Maybe<ResolversTypes['UserTypeEnum']>, ParentType, ContextType>,
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  studentPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  school?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  licenseStart?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  licenseEnd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  paid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  autoRenew?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  numAllowedGames?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  warningNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  professorKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  semesterId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type MarketCalcResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketCalc'] = ResolversParentTypes['MarketCalc']> = {
  marketCalcId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  roundIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  roundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  hasCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  timeSent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  teamIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>,
  messageType?: Resolver<ResolversTypes['MessageTypeEnum'], ParentType, ContextType>,
  sender?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  priority?: Resolver<ResolversTypes['MessagePriorityEnum'], ParentType, ContextType>,
  hasBeenRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  roundConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  productionDepreciationFix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  askGamesToMoveForward?: Resolver<Maybe<ResolversTypes['CheckGameFlowsResult']>, ParentType, ContextType>,
  importCourse?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<MutationImportCourseArgs, 'courseInput'>>,
  importCourseTemplate?: Resolver<Maybe<ResolversTypes['CourseTemplate']>, ParentType, ContextType, RequireFields<MutationImportCourseTemplateArgs, 'courseTemplateJSON' | 'name' | 'description'>>,
  updateCourseTemplate?: Resolver<Maybe<Array<Maybe<ResolversTypes['CourseTemplate']>>>, ParentType, ContextType, RequireFields<MutationUpdateCourseTemplateArgs, 'courseTemplateId'>>,
  adminCreateOrUpdateLicense?: Resolver<Maybe<ResolversTypes['License']>, ParentType, ContextType, RequireFields<MutationAdminCreateOrUpdateLicenseArgs, 'email' | 'licenseType'>>,
  createSemester?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationCreateSemesterArgs, 'input'>>,
  editSemester?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationEditSemesterArgs, 'input'>>,
  submitRoundElections?: Resolver<Maybe<ResolversTypes['RoundElection']>, ParentType, ContextType, RequireFields<MutationSubmitRoundElectionsArgs, 'input'>>,
  submitIncomeStatement?: Resolver<Maybe<ResolversTypes['IncomeStatement']>, ParentType, ContextType, RequireFields<MutationSubmitIncomeStatementArgs, 'input'>>,
  submitBalanceSheet?: Resolver<Maybe<ResolversTypes['BalanceSheet']>, ParentType, ContextType, RequireFields<MutationSubmitBalanceSheetArgs, 'input'>>,
  submitCashFlow?: Resolver<Maybe<ResolversTypes['CashFlow']>, ParentType, ContextType, RequireFields<MutationSubmitCashFlowArgs, 'input'>>,
  triggerMarketCalc?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationTriggerMarketCalcArgs, 'semesterId' | 'roundConfigId'>>,
  modifyRoundTimings?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationModifyRoundTimingsArgs, 'semesterId' | 'secondsPerRound'>>,
  toggleMaintenanceMode?: Resolver<Maybe<ResolversTypes['SystemStatusResponse']>, ParentType, ContextType>,
  resetGameToRoundWithRoundLength?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationResetGameToRoundWithRoundLengthArgs, 'semesterId' | 'roundToResetTo' | 'secondsPerRound'>>,
  resetGameToRoundWithTimestamps?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationResetGameToRoundWithTimestampsArgs, 'semesterId' | 'roundToResetTo' | 'roundTimingsToReset'>>,
  resetGameToBeforeLastMarketCalc?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationResetGameToBeforeLastMarketCalcArgs, 'semesterId'>>,
  removePlayer?: Resolver<Maybe<ResolversTypes['RemovePlayerResponse']>, ParentType, ContextType, RequireFields<MutationRemovePlayerArgs, 'studentId' | 'teamId'>>,
  prepAndRunSimulation?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationPrepAndRunSimulationArgs, 'input'>>,
  throwError?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>,
  switchTeams?: Resolver<Maybe<Array<Maybe<ResolversTypes['Team']>>>, ParentType, ContextType, RequireFields<MutationSwitchTeamsArgs, 'semesterId' | 'studentToMoveId' | 'oldTeamId' | 'newTeamId'>>,
  updateSemesterRoundTimings?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationUpdateSemesterRoundTimingsArgs, 'semesterId' | 'roundTimings'>>,
  extendGame?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationExtendGameArgs, 'semesterId' | 'numNewRounds'>>,
  toggleSemesterIsPaused?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, RequireFields<MutationToggleSemesterIsPausedArgs, 'semesterId'>>,
  sendMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationSendMessageArgs, 'input'>>,
  updateLastNotificationCheck?: Resolver<Maybe<ResolversTypes['LastNotificationCheck']>, ParentType, ContextType, RequireFields<MutationUpdateLastNotificationCheckArgs, 'teamId'>>,
  updateUserSettings?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateUserSettingsArgs, 'userSettings'>>,
  deleteCourseTemplate?: Resolver<Maybe<Array<Maybe<ResolversTypes['CourseTemplate']>>>, ParentType, ContextType, RequireFields<MutationDeleteCourseTemplateArgs, 'courseTemplateId'>>,
  removeStudentFromTeam?: Resolver<Maybe<Array<Maybe<ResolversTypes['Team']>>>, ParentType, ContextType, RequireFields<MutationRemoveStudentFromTeamArgs, 'studentId' | 'teamId'>>,
};

export type PreloadAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreloadAssets'] = ResolversParentTypes['PreloadAssets']> = {
  lands?: Resolver<Array<Maybe<ResolversTypes['PreloadLandAsset']>>, ParentType, ContextType>,
  buildings?: Resolver<Array<Maybe<ResolversTypes['PreloadBuildingAsset']>>, ParentType, ContextType>,
  equipments?: Resolver<Array<Maybe<ResolversTypes['PreloadEquipmentAsset']>>, ParentType, ContextType>,
  storeFurnishings?: Resolver<Array<Maybe<ResolversTypes['PreloadStoreFurnishingAsset']>>, ParentType, ContextType>,
  debts?: Resolver<Array<Maybe<ResolversTypes['PreloadDebtLiability']>>, ParentType, ContextType>,
  products?: Resolver<Array<Maybe<ResolversTypes['PreloadInventory']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type PreloadBuildingAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreloadBuildingAsset'] = ResolversParentTypes['PreloadBuildingAsset']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  land?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  depreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type PreloadDebtLiabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreloadDebtLiability'] = ResolversParentTypes['PreloadDebtLiability']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  originalRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  originalTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type PreloadEquipmentAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreloadEquipmentAsset'] = ResolversParentTypes['PreloadEquipmentAsset']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  building?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  depreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type PreloadInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreloadInventory'] = ResolversParentTypes['PreloadInventory']> = {
  gameProductName?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  inventoryAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  costPerUnit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type PreloadLandAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreloadLandAsset'] = ResolversParentTypes['PreloadLandAsset']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type PreloadStoreFurnishingAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreloadStoreFurnishingAsset'] = ResolversParentTypes['PreloadStoreFurnishingAsset']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  building?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  depreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ProductConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfig'] = ResolversParentTypes['ProductConfig']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  gameProductId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  productionCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  demandSlope?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  demandIntercept?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ProductElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductElection'] = ResolversParentTypes['ProductElection']> = {
  productConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  gameProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  quantityOffered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  offerPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  numUnitsToAdvertise?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ProductInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductInventory'] = ResolversParentTypes['ProductInventory']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  gameProduct?: Resolver<Maybe<ResolversTypes['GameProduct']>, ParentType, ContextType>,
  roundConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  productConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  originalInventoryAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  outstandingInventoryAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  costPerUnit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  inventoryChanges?: Resolver<Maybe<Array<Maybe<ResolversTypes['InventoryChange']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ProductInventoryReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductInventoryReport'] = ResolversParentTypes['ProductInventoryReport']> = {
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  gameProduct?: Resolver<Maybe<ResolversTypes['GameProduct']>, ParentType, ContextType>,
  inventoryAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QueryCourseArgs, 'id'>>,
  courses?: Resolver<Maybe<Array<Maybe<ResolversTypes['Course']>>>, ParentType, ContextType>,
  currentAssets?: Resolver<Maybe<ResolversTypes['CurrentAssets']>, ParentType, ContextType, RequireFields<QueryCurrentAssetsArgs, 'teamId'>>,
  studentSemesters?: Resolver<Maybe<Array<Maybe<ResolversTypes['Semester']>>>, ParentType, ContextType>,
  professorSemesters?: Resolver<Maybe<Array<Maybe<ResolversTypes['Semester']>>>, ParentType, ContextType>,
  semesterByCode?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType, QuerySemesterByCodeArgs>,
  election?: Resolver<Maybe<ResolversTypes['RoundElection']>, ParentType, ContextType, RequireFields<QueryElectionArgs, 'roundConfigId' | 'teamId'>>,
  elections?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoundElection']>>>, ParentType, ContextType, RequireFields<QueryElectionsArgs, 'teamId'>>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType, RequireFields<QueryTeamArgs, 'teamId'>>,
  getCurrentLicense?: Resolver<Maybe<ResolversTypes['License']>, ParentType, ContextType, RequireFields<QueryGetCurrentLicenseArgs, 'userEmail'>>,
  adminLicenses?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserLicenseStatus']>>>, ParentType, ContextType>,
  professorLicenses?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserLicenseStatus']>>>, ParentType, ContextType>,
  studentLicenses?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserLicenseStatus']>>>, ParentType, ContextType>,
  professorTeams?: Resolver<Maybe<Array<Maybe<ResolversTypes['Team']>>>, ParentType, ContextType, RequireFields<QueryProfessorTeamsArgs, 'semesterId'>>,
  gameState?: Resolver<Maybe<ResolversTypes['GameState']>, ParentType, ContextType, RequireFields<QueryGameStateArgs, 'semesterId'>>,
  incomeStatement?: Resolver<Maybe<ResolversTypes['IncomeStatement']>, ParentType, ContextType, RequireFields<QueryIncomeStatementArgs, 'roundConfigId' | 'teamId'>>,
  balanceSheet?: Resolver<Maybe<ResolversTypes['BalanceSheet']>, ParentType, ContextType, RequireFields<QueryBalanceSheetArgs, 'roundConfigId' | 'teamId'>>,
  cashFlow?: Resolver<Maybe<ResolversTypes['CashFlow']>, ParentType, ContextType, RequireFields<QueryCashFlowArgs, 'teamId'>>,
  salesReport?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesReportEntry']>>>, ParentType, ContextType, RequireFields<QuerySalesReportArgs, 'roundConfigId' | 'teamId'>>,
  gradingReport?: Resolver<Maybe<ResolversTypes['GradingReport']>, ParentType, ContextType, RequireFields<QueryGradingReportArgs, 'roundConfigId' | 'teamId'>>,
  remainingInventoryCosts?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoundInventoryCosts']>>>, ParentType, ContextType, RequireFields<QueryRemainingInventoryCostsArgs, 'teamId' | 'roundConfigId'>>,
  scoreboardData?: Resolver<Maybe<ResolversTypes['ScoreboardData']>, ParentType, ContextType, RequireFields<QueryScoreboardDataArgs, 'semesterId'>>,
  systemStatus?: Resolver<Maybe<ResolversTypes['SystemStatusResponse']>, ParentType, ContextType>,
  teamInfo?: Resolver<Maybe<Array<Maybe<ResolversTypes['Team']>>>, ParentType, ContextType, RequireFields<QueryTeamInfoArgs, 'semesterId'>>,
  generateRoundTimings?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoundTiming']>>>, ParentType, ContextType, RequireFields<QueryGenerateRoundTimingsArgs, 'courseId' | 'startTime' | 'timezone'>>,
  exportSimulationDataFromGame?: Resolver<Maybe<ResolversTypes['SimulationData']>, ParentType, ContextType, RequireFields<QueryExportSimulationDataFromGameArgs, 'semesterId'>>,
  exportGameResults?: Resolver<Maybe<ResolversTypes['GameResults']>, ParentType, ContextType, RequireFields<QueryExportGameResultsArgs, 'semesterId'>>,
  generalLedger?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeneralLedgerTableEntry']>>>, ParentType, ContextType, RequireFields<QueryGeneralLedgerArgs, 'semesterId'>>,
  journalEntriesAndTAccounts?: Resolver<Maybe<ResolversTypes['JournalEntriesAndTAccountsResponse']>, ParentType, ContextType, RequireFields<QueryJournalEntriesAndTAccountsArgs, 'roundConfigId' | 'teamId'>>,
  validateAdminLicense?: Resolver<Maybe<ResolversTypes['License']>, ParentType, ContextType, RequireFields<QueryValidateAdminLicenseArgs, 'userEmail'>>,
  stockTicker?: Resolver<Maybe<Array<Maybe<ResolversTypes['StockTickerDataPoint']>>>, ParentType, ContextType, RequireFields<QueryStockTickerArgs, 'semesterId' | 'roundConfigId'>>,
  getStockPriceForTeam?: Resolver<Maybe<ResolversTypes['TeamStockResponse']>, ParentType, ContextType, RequireFields<QueryGetStockPriceForTeamArgs, 'roundConfigId' | 'teamId'>>,
  userByEmail?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserByEmailArgs, 'email'>>,
  financialRatios?: Resolver<Maybe<Array<Maybe<ResolversTypes['FinancialRatio']>>>, ParentType, ContextType, RequireFields<QueryFinancialRatiosArgs, 'semesterId' | 'roundConfigId'>>,
  autoScheduleRoundTimings?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoundTiming']>>>, ParentType, ContextType, RequireFields<QueryAutoScheduleRoundTimingsArgs, 'roundToBeginGeneratingNewTimings' | 'passedInRoundTiming' | 'timezone'>>,
  validateRoundTimings?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoundTiming']>>>, ParentType, ContextType, RequireFields<QueryValidateRoundTimingsArgs, 'roundTimings' | 'timezone'>>,
  getMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['Message']>>>, ParentType, ContextType, RequireFields<QueryGetMessagesArgs, 'teamId'>>,
  getCustomLabels?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomLabel']>>>, ParentType, ContextType, RequireFields<QueryGetCustomLabelsArgs, 'semesterId'>>,
  courseTemplates?: Resolver<Maybe<Array<Maybe<ResolversTypes['CourseTemplate']>>>, ParentType, ContextType, QueryCourseTemplatesArgs>,
  courseTemplateAsInputString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryCourseTemplateAsInputStringArgs, 'courseTemplateId'>>,
  courseAsCourseTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryCourseAsCourseTemplateArgs, 'courseId'>>,
};

export type RemainingInventoryCostsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemainingInventoryCosts'] = ResolversParentTypes['RemainingInventoryCosts']> = {
  gameProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  gameProductName?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  remainingUnits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type RemovePlayerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemovePlayerResponse'] = ResolversParentTypes['RemovePlayerResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingBsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingBS'] = ResolversParentTypes['ResultingBS']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  cash?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  inventory?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  equipment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  equipmentDepreciation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  buildings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  buildingsDepreciation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  land?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  totalAssets?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  loanPayable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  totalLiabilities?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  commonStock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  retainedEarnings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  totalLiabilitiesAndEquity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingBuildingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingBuilding'] = ResolversParentTypes['ResultingBuilding']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  buildingConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  annualDepreciationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  expiringRoundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  depreciationChanges?: Resolver<Array<Maybe<ResolversTypes['ResultingDepreciationChange']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingCfResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingCF'] = ResolversParentTypes['ResultingCF']> = {
  team?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  operatingActivitiesSales?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesPurchasedInventory?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesPaidAdvertising?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesSalesReturns?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesIncomeTaxesPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesInterestPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  operatingActivitiesTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesInflowEquipment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesInflowBuildings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesInflowLand?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesOutflowEquipment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesOutflowBuildings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesOutflowLand?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  investingActivitiesTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesCapital?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesLoanBorrow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesLoanRepay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financingActivitiesTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  netCash?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  beginningOfRound?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  endOfRound?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingDebtResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingDebt'] = ResolversParentTypes['ResultingDebt']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  debtConfigId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  originalRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  originalTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  roundBorrowedIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  repayments?: Resolver<Array<Maybe<ResolversTypes['ResultingDebtRepayment']>>, ParentType, ContextType>,
  repaymentRoundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingDebtRepaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingDebtRepayment'] = ResolversParentTypes['ResultingDebtRepayment']> = {
  timeStamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  repaymentRoundId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  repaymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingDepreciationChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingDepreciationChange'] = ResolversParentTypes['ResultingDepreciationChange']> = {
  timeStamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  depreciationExpense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingEquipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingEquipment'] = ResolversParentTypes['ResultingEquipment']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  equipmentConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  annualDepreciationPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  expiringRoundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  depreciationChanges?: Resolver<Array<Maybe<ResolversTypes['ResultingDepreciationChange']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingGlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingGL'] = ResolversParentTypes['ResultingGL']> = {
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingInventory'] = ResolversParentTypes['ResultingInventory']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  gameProduct?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  productConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  originalInventoryAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  costPerUnit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  inventoryChanges?: Resolver<Array<Maybe<ResolversTypes['ResultingInventoryChange']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingInventoryChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingInventoryChange'] = ResolversParentTypes['ResultingInventoryChange']> = {
  timeStamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  inventoryAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingIsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingIS'] = ResolversParentTypes['ResultingIS']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  revenue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  returns?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  net?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  costOfGoodsSold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  grossProfit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  adExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  interest?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  gainOnAssetSales?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  accountsReceivable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  badDebtExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  incomeTax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  netIncome?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingLandResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingLand'] = ResolversParentTypes['ResultingLand']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  landConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingSalesReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingSalesReport'] = ResolversParentTypes['ResultingSalesReport']> = {
  roundConfigId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  gameProduct?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  offerPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  perceivedPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  unitsSold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  unitsOffered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  isAdvertised?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  isInventory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ResultingStoreFurnishingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResultingStoreFurnishing'] = ResolversParentTypes['ResultingStoreFurnishing']> = {
  team?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  furnishingConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  totalCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  originalPurchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  annualDepreciationPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  expiringRoundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  depreciationChanges?: Resolver<Array<Maybe<ResolversTypes['ResultingDepreciationChange']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type RoundConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundConfig'] = ResolversParentTypes['RoundConfig']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  salesReturnsPercentLowerBound?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  salesReturnsPercentUpperBound?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  buildings?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuildingConfig']>>>, ParentType, ContextType>,
  equipments?: Resolver<Maybe<Array<Maybe<ResolversTypes['EquipmentConfig']>>>, ParentType, ContextType>,
  lands?: Resolver<Maybe<Array<Maybe<ResolversTypes['LandConfig']>>>, ParentType, ContextType>,
  storeFurnishings?: Resolver<Maybe<Array<Maybe<ResolversTypes['StoreFurnishingConfig']>>>, ParentType, ContextType>,
  debts?: Resolver<Maybe<Array<Maybe<ResolversTypes['DebtConfig']>>>, ParentType, ContextType>,
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductConfig']>>>, ParentType, ContextType>,
  isStockTradingEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  bonds?: Resolver<ResolversTypes['BondsConfig'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type RoundElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundElection'] = ResolversParentTypes['RoundElection']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  semester?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  buildingPurchases?: Resolver<Array<ResolversTypes['BuildingPurchaseElection']>, ParentType, ContextType>,
  buildingSales?: Resolver<Array<ResolversTypes['BuildingSaleElection']>, ParentType, ContextType>,
  equipmentPurchases?: Resolver<Array<ResolversTypes['EquipmentPurchaseElection']>, ParentType, ContextType>,
  equipmentSales?: Resolver<Array<ResolversTypes['EquipmentSaleElection']>, ParentType, ContextType>,
  landPurchases?: Resolver<Array<ResolversTypes['LandPurchaseElection']>, ParentType, ContextType>,
  landSales?: Resolver<Array<ResolversTypes['LandSaleElection']>, ParentType, ContextType>,
  storeFurnishingPurchases?: Resolver<Array<ResolversTypes['StoreFurnishingPurchaseElection']>, ParentType, ContextType>,
  storeFurnishingSales?: Resolver<Array<ResolversTypes['StoreFurnishingSaleElection']>, ParentType, ContextType>,
  debtsBorrowed?: Resolver<Array<ResolversTypes['DebtBorrowElection']>, ParentType, ContextType>,
  debtsRepayed?: Resolver<Array<ResolversTypes['DebtRepaymentElection']>, ParentType, ContextType>,
  productElections?: Resolver<Array<ResolversTypes['ProductElection']>, ParentType, ContextType>,
  stockSales?: Resolver<Array<ResolversTypes['StockSaleElection']>, ParentType, ContextType>,
  bondSales?: Resolver<Array<ResolversTypes['BondSaleElection']>, ParentType, ContextType>,
  submittedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>,
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type RoundInventoryCostsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundInventoryCosts'] = ResolversParentTypes['RoundInventoryCosts']> = {
  roundIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  inventoryCosts?: Resolver<Array<Maybe<ResolversTypes['RemainingInventoryCosts']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type RoundSalesReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundSalesReturn'] = ResolversParentTypes['RoundSalesReturn']> = {
  teamId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  assignedSalesReturnsPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type RoundTimingResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundTiming'] = ResolversParentTypes['RoundTiming']> = {
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  electionsOpen?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  electionsDeadline?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  secondSubmissionDeadline?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  gradeViewingDeadline?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  hasCalculatedMarket?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  hasGraded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  marketCalcId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type SalesReportEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesReportEntry'] = ResolversParentTypes['SalesReportEntry']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  roundConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  roundIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  gameProduct?: Resolver<Maybe<ResolversTypes['GameProduct']>, ParentType, ContextType>,
  offerPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  perceivedPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  unitsSold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  unitsOffered?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  isAdvertised?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  isInventory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  previousRoundAR?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ScoreboardDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreboardData'] = ResolversParentTypes['ScoreboardData']> = {
  semesterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  numRoundsCompleted?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  numTotalRounds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  rounds?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoreboardRound']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ScoreboardRoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreboardRound'] = ResolversParentTypes['ScoreboardRound']> = {
  roundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  roundNum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  teamDatas?: Resolver<Array<Maybe<ResolversTypes['ScoreboardTeamDataPoint']>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type ScoreboardTeamDataPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreboardTeamDataPoint'] = ResolversParentTypes['ScoreboardTeamDataPoint']> = {
  teamId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  teamName?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  teamColorCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  currentRoundIncome?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  previousRoundsTotalNetIncome?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type SemesterResolvers<ContextType = any, ParentType extends ResolversParentTypes['Semester'] = ResolversParentTypes['Semester']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  season?: Resolver<Maybe<ResolversTypes['SemesterSeason']>, ParentType, ContextType>,
  startTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  endTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  numTeams?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  numStudentsPerTeam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  onboardCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  professors?: Resolver<Array<Maybe<ResolversTypes['User']>>, ParentType, ContextType>,
  teams?: Resolver<Maybe<Array<Maybe<ResolversTypes['Team']>>>, ParentType, ContextType>,
  roundTimings?: Resolver<Array<Maybe<ResolversTypes['RoundTiming']>>, ParentType, ContextType>,
  teamColors?: Resolver<Maybe<Array<Maybe<ResolversTypes['TeamColor']>>>, ParentType, ContextType>,
  teamSalesReturns?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['RoundSalesReturn']>>>>, ParentType, ContextType>,
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  useFlowMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  gameConfig?: Resolver<ResolversTypes['GameConfig'], ParentType, ContextType>,
  hasDistributedPreloadedAssets?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  currentRoundIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  roundNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  electionsDue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  financialsDue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  currentGamePhase?: Resolver<Maybe<ResolversTypes['GameRoundPhase']>, ParentType, ContextType>,
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  studentPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  professorLicenseKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  isPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type SimulationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationData'] = ResolversParentTypes['SimulationData']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  teamInputs?: Resolver<Array<ResolversTypes['SimulationTeam']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type SimulationSheetResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationSheet'] = ResolversParentTypes['SimulationSheet']> = {
  incomeStatement?: Resolver<Maybe<ResolversTypes['IncomeStatement']>, ParentType, ContextType>,
  balanceSheet?: Resolver<Maybe<ResolversTypes['BalanceSheet']>, ParentType, ContextType>,
  cashFlow?: Resolver<Maybe<ResolversTypes['CashFlow']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type SimulationTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationTeam'] = ResolversParentTypes['SimulationTeam']> = {
  teamName?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  roundSalesReturns?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>,
  elections?: Resolver<Array<ResolversTypes['RoundElection']>, ParentType, ContextType>,
  sheets?: Resolver<Array<ResolversTypes['SimulationSheet']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StockConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockConfig'] = ResolversParentTypes['StockConfig']> = {
  teamStartingStockPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  initialOfferingNumShares?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  totalSellableSharesPerTeam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StockPriceFormulaConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockPriceFormulaConfig'] = ResolversParentTypes['StockPriceFormulaConfig']> = {
  netIncomeFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  totalAssetsFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  changeInIncomeFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  niRankFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StockSaleElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockSaleElection'] = ResolversParentTypes['StockSaleElection']> = {
  quantityOffered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  stockPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StockTickerDataPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockTickerDataPoint'] = ResolversParentTypes['StockTickerDataPoint']> = {
  team?: Resolver<ResolversTypes['Team'], ParentType, ContextType>,
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  roundIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  stockPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  changeFromPreviousRound?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StoreFurnishingAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreFurnishingAsset'] = ResolversParentTypes['StoreFurnishingAsset']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  furnishingConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  purchaseElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  saleElectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  totalCapacity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  usefulLife?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  remainingUsefulLife?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  roundPurchasedIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  originalPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  isSellable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  isSold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>,
  depreciationMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  annualDepreciationPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  depreciationExpense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  a_d?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  expiringRoundId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  friendlyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  originalRoundPurchasedNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StoreFurnishingConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreFurnishingConfig'] = ResolversParentTypes['StoreFurnishingConfig']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  typesConfig?: Resolver<Maybe<Array<Maybe<ResolversTypes['StoreFurnishingTypeDynamicConfig']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StoreFurnishingPurchaseElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreFurnishingPurchaseElection'] = ResolversParentTypes['StoreFurnishingPurchaseElection']> = {
  furnishingConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  purchasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  depreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  capacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StoreFurnishingSaleElectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreFurnishingSaleElection'] = ResolversParentTypes['StoreFurnishingSaleElection']> = {
  furnishingAssetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  furnishingConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  salePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  originalPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type StoreFurnishingTypeDynamicConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreFurnishingTypeDynamicConfig'] = ResolversParentTypes['StoreFurnishingTypeDynamicConfig']> = {
  miniId?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  furnishingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  purchaseCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  productionCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  usefulLife?: Resolver<ResolversTypes['Int'], ParentType, ContextType>,
  depreciationMethods?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>,
  defaultDepreciationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type SystemStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemStatusResponse'] = ResolversParentTypes['SystemStatusResponse']> = {
  text?: Resolver<Maybe<ResolversTypes['SystemStatusEnum']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type TAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TAccount'] = ResolversParentTypes['TAccount']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>,
  friendlyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  normalBalance?: Resolver<Maybe<ResolversTypes['NormalBalance']>, ParentType, ContextType>,
  type?: Resolver<Maybe<ResolversTypes['TAccountType']>, ParentType, ContextType>,
  beginningBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  endingBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  roundConfigId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>,
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>,
  entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeneralLedgerEntry']>>>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type TeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['Team'] = ResolversParentTypes['Team']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  semester?: Resolver<Maybe<ResolversTypes['Semester']>, ParentType, ContextType>,
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  students?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>,
  colorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  stockSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type TeamColorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamColor'] = ResolversParentTypes['TeamColor']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  hexCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type TeamStockResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamStockResponse'] = ResolversParentTypes['TeamStockResponse']> = {
  roundConfigId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  stockPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload'
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  userName?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  loginCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  canBeProfessor?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  settings?: Resolver<Maybe<ResolversTypes['UserSettings']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type UserLicenseStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLicenseStatus'] = ResolversParentTypes['UserLicenseStatus']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  currentLicense?: Resolver<Maybe<ResolversTypes['License']>, ParentType, ContextType>,
  licenseStatus?: Resolver<ResolversTypes['LicenseStatusEnum'], ParentType, ContextType>,
  pendingLicense?: Resolver<Maybe<ResolversTypes['License']>, ParentType, ContextType>,
  warningNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  durationOfWarning?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type UserSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSettings'] = ResolversParentTypes['UserSettings']> = {
  emailPreference?: Resolver<Maybe<ResolversTypes['EmailPreference']>, ParentType, ContextType>,
  __isTypeOf?: isTypeOfResolverFn,
};

export type Resolvers<ContextType = any> = {
  AdvertisingFeature?: AdvertisingFeatureResolvers<ContextType>,
  ARRoundFeature?: ArRoundFeatureResolvers<ContextType>,
  BalanceSheet?: BalanceSheetResolvers<ContextType>,
  BalanceSheetConfig?: BalanceSheetConfigResolvers<ContextType>,
  BondAsset?: BondAssetResolvers<ContextType>,
  BondLiability?: BondLiabilityResolvers<ContextType>,
  BondOptions?: BondOptionsResolvers<ContextType>,
  BondSaleElection?: BondSaleElectionResolvers<ContextType>,
  BondsConfig?: BondsConfigResolvers<ContextType>,
  BorrowingCapsFeature?: BorrowingCapsFeatureResolvers<ContextType>,
  BuildingAsset?: BuildingAssetResolvers<ContextType>,
  BuildingConfig?: BuildingConfigResolvers<ContextType>,
  BuildingPurchaseElection?: BuildingPurchaseElectionResolvers<ContextType>,
  BuildingSaleElection?: BuildingSaleElectionResolvers<ContextType>,
  BuildingTypeDynamicConfig?: BuildingTypeDynamicConfigResolvers<ContextType>,
  CashFlow?: CashFlowResolvers<ContextType>,
  CashFlowConfig?: CashFlowConfigResolvers<ContextType>,
  CheckGameFlowsResult?: CheckGameFlowsResultResolvers<ContextType>,
  Course?: CourseResolvers<ContextType>,
  CourseTemplate?: CourseTemplateResolvers<ContextType>,
  CurrentAssets?: CurrentAssetsResolvers<ContextType>,
  CustomLabel?: CustomLabelResolvers<ContextType>,
  DebtBorrowElection?: DebtBorrowElectionResolvers<ContextType>,
  DebtConfig?: DebtConfigResolvers<ContextType>,
  DebtLiability?: DebtLiabilityResolvers<ContextType>,
  DebtRepayment?: DebtRepaymentResolvers<ContextType>,
  DebtRepaymentElection?: DebtRepaymentElectionResolvers<ContextType>,
  EquipmentAsset?: EquipmentAssetResolvers<ContextType>,
  EquipmentConfig?: EquipmentConfigResolvers<ContextType>,
  EquipmentPurchaseElection?: EquipmentPurchaseElectionResolvers<ContextType>,
  EquipmentSaleElection?: EquipmentSaleElectionResolvers<ContextType>,
  EquipmentTypeDynamicConfig?: EquipmentTypeDynamicConfigResolvers<ContextType>,
  Error?: ErrorResolvers<ContextType>,
  FieldAnswer?: FieldAnswerResolvers<ContextType>,
  FinancialRatio?: FinancialRatioResolvers<ContextType>,
  GameConfig?: GameConfigResolvers<ContextType>,
  GameConfigRoundFeatures?: GameConfigRoundFeaturesResolvers<ContextType>,
  GameProduct?: GameProductResolvers<ContextType>,
  GameResults?: GameResultsResolvers<ContextType>,
  GameRoundTuple?: GameRoundTupleResolvers<ContextType>,
  GameState?: GameStateResolvers<ContextType>,
  GeneralLedgerEntry?: GeneralLedgerEntryResolvers<ContextType>,
  GeneralLedgerTableEntry?: GeneralLedgerTableEntryResolvers<ContextType>,
  GradingReport?: GradingReportResolvers<ContextType>,
  IncomeStatement?: IncomeStatementResolvers<ContextType>,
  IncomeStatementConfig?: IncomeStatementConfigResolvers<ContextType>,
  InventoryChange?: InventoryChangeResolvers<ContextType>,
  JournalEntriesAndTAccountsResponse?: JournalEntriesAndTAccountsResponseResolvers<ContextType>,
  JournalEntry?: JournalEntryResolvers<ContextType>,
  JunkLoanConfig?: JunkLoanConfigResolvers<ContextType>,
  LandAsset?: LandAssetResolvers<ContextType>,
  LandConfig?: LandConfigResolvers<ContextType>,
  LandPurchaseElection?: LandPurchaseElectionResolvers<ContextType>,
  LandSaleElection?: LandSaleElectionResolvers<ContextType>,
  LastNotificationCheck?: LastNotificationCheckResolvers<ContextType>,
  License?: LicenseResolvers<ContextType>,
  MarketCalc?: MarketCalcResolvers<ContextType>,
  Message?: MessageResolvers<ContextType>,
  Mutation?: MutationResolvers<ContextType>,
  PreloadAssets?: PreloadAssetsResolvers<ContextType>,
  PreloadBuildingAsset?: PreloadBuildingAssetResolvers<ContextType>,
  PreloadDebtLiability?: PreloadDebtLiabilityResolvers<ContextType>,
  PreloadEquipmentAsset?: PreloadEquipmentAssetResolvers<ContextType>,
  PreloadInventory?: PreloadInventoryResolvers<ContextType>,
  PreloadLandAsset?: PreloadLandAssetResolvers<ContextType>,
  PreloadStoreFurnishingAsset?: PreloadStoreFurnishingAssetResolvers<ContextType>,
  ProductConfig?: ProductConfigResolvers<ContextType>,
  ProductElection?: ProductElectionResolvers<ContextType>,
  ProductInventory?: ProductInventoryResolvers<ContextType>,
  ProductInventoryReport?: ProductInventoryReportResolvers<ContextType>,
  Query?: QueryResolvers<ContextType>,
  RemainingInventoryCosts?: RemainingInventoryCostsResolvers<ContextType>,
  RemovePlayerResponse?: RemovePlayerResponseResolvers<ContextType>,
  ResultingBS?: ResultingBsResolvers<ContextType>,
  ResultingBuilding?: ResultingBuildingResolvers<ContextType>,
  ResultingCF?: ResultingCfResolvers<ContextType>,
  ResultingDebt?: ResultingDebtResolvers<ContextType>,
  ResultingDebtRepayment?: ResultingDebtRepaymentResolvers<ContextType>,
  ResultingDepreciationChange?: ResultingDepreciationChangeResolvers<ContextType>,
  ResultingEquipment?: ResultingEquipmentResolvers<ContextType>,
  ResultingGL?: ResultingGlResolvers<ContextType>,
  ResultingInventory?: ResultingInventoryResolvers<ContextType>,
  ResultingInventoryChange?: ResultingInventoryChangeResolvers<ContextType>,
  ResultingIS?: ResultingIsResolvers<ContextType>,
  ResultingLand?: ResultingLandResolvers<ContextType>,
  ResultingSalesReport?: ResultingSalesReportResolvers<ContextType>,
  ResultingStoreFurnishing?: ResultingStoreFurnishingResolvers<ContextType>,
  RoundConfig?: RoundConfigResolvers<ContextType>,
  RoundElection?: RoundElectionResolvers<ContextType>,
  RoundInventoryCosts?: RoundInventoryCostsResolvers<ContextType>,
  RoundSalesReturn?: RoundSalesReturnResolvers<ContextType>,
  RoundTiming?: RoundTimingResolvers<ContextType>,
  SalesReportEntry?: SalesReportEntryResolvers<ContextType>,
  ScoreboardData?: ScoreboardDataResolvers<ContextType>,
  ScoreboardRound?: ScoreboardRoundResolvers<ContextType>,
  ScoreboardTeamDataPoint?: ScoreboardTeamDataPointResolvers<ContextType>,
  Semester?: SemesterResolvers<ContextType>,
  SimulationData?: SimulationDataResolvers<ContextType>,
  SimulationSheet?: SimulationSheetResolvers<ContextType>,
  SimulationTeam?: SimulationTeamResolvers<ContextType>,
  StockConfig?: StockConfigResolvers<ContextType>,
  StockPriceFormulaConfig?: StockPriceFormulaConfigResolvers<ContextType>,
  StockSaleElection?: StockSaleElectionResolvers<ContextType>,
  StockTickerDataPoint?: StockTickerDataPointResolvers<ContextType>,
  StoreFurnishingAsset?: StoreFurnishingAssetResolvers<ContextType>,
  StoreFurnishingConfig?: StoreFurnishingConfigResolvers<ContextType>,
  StoreFurnishingPurchaseElection?: StoreFurnishingPurchaseElectionResolvers<ContextType>,
  StoreFurnishingSaleElection?: StoreFurnishingSaleElectionResolvers<ContextType>,
  StoreFurnishingTypeDynamicConfig?: StoreFurnishingTypeDynamicConfigResolvers<ContextType>,
  SystemStatusResponse?: SystemStatusResponseResolvers<ContextType>,
  TAccount?: TAccountResolvers<ContextType>,
  Team?: TeamResolvers<ContextType>,
  TeamColor?: TeamColorResolvers<ContextType>,
  TeamStockResponse?: TeamStockResponseResolvers<ContextType>,
  Upload?: GraphQLScalarType,
  User?: UserResolvers<ContextType>,
  UserLicenseStatus?: UserLicenseStatusResolvers<ContextType>,
  UserSettings?: UserSettingsResolvers<ContextType>,
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
*/
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = {
  cacheControl?: CacheControlDirectiveResolver<any, any, ContextType>,
};


/**
* @deprecated
* Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
*/
export type IDirectiveResolvers<ContextType = any> = DirectiveResolvers<ContextType>;